<template>
  <div>
    <!-- <el-button type="text" @click="dialogVisible = true">Dialog</el-button> -->
    <div align="left" style="padding-top:40px;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" style="width:230px" @click="jump('/empList')">新入社員情報登録</el-button>
      <el-button type="primary" icon="el-icon-data-analysis" style="width:230px" @click="dialogCompMonthSalary = true">会社月度給与明細管理</el-button>
      <el-button type="primary" icon="el-icon-data-analysis" style="width:230px" @click="dialogCompYearSalary = true">会社年度給与明細一覧</el-button>
      <el-button type="primary" icon="el-icon-upload" style="width:230px" @click="dialogUploadExcel = true">給与明細データインポート</el-button>
    </div>
    <el-table @sort-change="changeTableSort" :data="tableData" highlight-current-row border style="width: 100%; margin-top: 39px; margin-bottom: 20px" :empty-text="$t('general.empty_data')">
      <el-table-column sortable="custom" prop="employee_id" :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="employee_type" :label="$t('empList.title')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_type }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.salary_month')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.salary_month }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-document" @click="handleSalary(scope.$index, scope.row)">
            給与明細</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="jump('/empList')">
            従業員情報変更</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 会社月度給与明細一覧 -->
    <el-dialog title="会社月度給与明細一覧" :visible.sync="dialogCompMonthSalary" width="83%" :before-close="handleCloseCompMonthSalary">
      <div style="text-align:left;">
        <el-form v-loading="loading" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <div style="padding-bottom:10px;color:red;font-size:12px;">
            <el-row>
              <ei-col :span="24">
                <p>
                  *&nbsp;HRBOXシステムのpdf出力機能は、一部の日本語入力方式に存在しない漢字を適切にサポートしていません。<br>
                  &nbsp;&nbsp;個々の漢字に文字化けが表示される場合は、漢字を日本語ひらがなやかたかなに置き換えてください。<br>
                  &nbsp;&nbsp;追加更新内容：社員氏名は中国語簡体字を適切にサポートしています。
                </p>
              </ei-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="4">
                <el-form-item label="月" prop="" size="mini" style="width: 100%;">
                  <el-date-picker v-model="ruleForm.salaryDate" type="month" placeholder="選択" style="width:110px;" value-format="yyyy-MM"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="compMonthSalary" size="mini" style="width:100px;" icon="el-icon-search">検索</el-button>
                <el-button type="primary" @click="sendMailTotally" size="mini" style="width:100px;" icon="el-icon-message">一括送信</el-button>
              </el-col>
              <el-col :span="14">
                <div style="text-align:right;">
                  <el-button type="primary" @click="printCompMonthSalary('ruleForm')" icon="el-icon-view" size="mini">月度給与明細一覧</el-button>
                  <el-button type="primary" @click="printSocialInsurance('ruleForm')" icon="el-icon-view" size="mini">社会保険料一覧</el-button>
                  <el-button type="primary" @click="printSalaryBank('ruleForm')" icon="el-icon-view" size="mini">総合振込依頼書</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div style="padding-top:30px;">
        <el-table :data="compMonthSalaryData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
          <el-table-column label="社員番号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employee_id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="総支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.salary_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="控除合計額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deduction_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="差引支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.actually_payment }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="220px">
            <template slot-scope="scope">
              　<el-button size="mini" type="success" icon="el-icon-message" @click="handleSandSalaryMonth(scope.$index, scope.row)">送信</el-button>
              <el-button size="mini" type="primary" icon="el-icon-info" @click="ListSalaryByYearMonth(scope.$index, scope.row)">詳細情報</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage3" small layout="prev, pager, next" :page-size="pageSize" :total="total3" @current-change="compMonthSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 個人月度給与明細書送付 -->
    <el-dialog title="給与明細書を送付しています" :visible.sync="dialogSendSalaryTableMonth" width="70%" :before-close="cancelSend">
      <el-form v-loading="loading" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div style="text-align:left;">
              <el-form-item label="社員名">
                :&emsp;{{ruleForm.name}}
              </el-form-item>
              <el-form-item label="社員番号">
                :&emsp;{{ruleForm.employee_id}}
              </el-form-item>
              <el-form-item label="メールアドレス">
                :&emsp;{{ruleForm.email}}
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" size="medium" type="primary" icon="el-icon-message" @click="sendSalaryTableMonth('ruleForm')">送信</el-button>
        <el-button style="width: 120px" @click="cancelSend()" type="primary" size="medium">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- 会社年度給与明細一覧 -->
    <el-dialog title="会社年度給与明細一覧" :visible.sync="dialogCompYearSalary" width="83%" :before-close="handleClose">
      <div style="text-align:left;">
        <el-form v-loading="loading" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <el-row>
            <el-col :span="3">
              <el-form-item label="年" prop="year" size="mini" style="width: 100%;">
                <el-date-picker v-model="ruleForm.year" type="year" placeholder="選択" style="width:100px;" value-format="yyyy"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="compYearSalary" size="mini" icon="el-icon-search">検索</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="printCompanySalaryYearList('ruleForm')" icon="el-icon-view" size="mini">詳細情報プレビュー</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="padding-top:30px;">
        <el-table :data="compYearSalaryData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
          <el-table-column label="月" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.month }}</span>
            </template>
          </el-table-column>

          <el-table-column label="総支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.salary_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="控除合計額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deduction_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="差引支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.actually_payment }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage4" small layout="prev, pager, next" :page-size="pageSize" :total="total4" @current-change="compYearSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 給与明細書作成 -->
    <el-dialog title="給与明細書作成" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <div style="padding-bottom:10px;color:red;font-size:12px;text-align:left;">
          <el-row>
            <ei-col :span="24">
              <p>
                *&nbsp;HRBOXシステムのpdf出力機能は、一部の日本語入力方式に存在しない漢字を適切にサポートしていません。<br>
                &nbsp;&nbsp;個々の漢字に文字化けが表示される場合は、漢字を日本語ひらがなやかたかなに置き換えてください。<br>
                &nbsp;&nbsp;追加更新内容：社員氏名は中国語簡体字を適切にサポートしています。
              </p>
            </ei-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="12">
            <div style="text-align:left;">
              <el-form-item label="社員名">
                :&emsp;{{ruleForm.name}}
              </el-form-item>
              <el-form-item label="社員番号">
                :&emsp;{{ruleForm.employee_id}}
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="text-align:right;">
              <el-form-item>
                <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="salaryAdd">給与明細書計算
                </el-button>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="salaryDetailsData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')" v-loading="loading">
        <el-table-column label="日付" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.year }}</span>
            <span>/</span>
            <span>{{ scope.row.month }}</span>
          </template>
        </el-table-column>

        <el-table-column label="総支給額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.salary_total }}</span>
          </template>
        </el-table-column>

        <el-table-column label="控除合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.deduction_total }}</span>
          </template>
        </el-table-column>

        <el-table-column label="差引支給額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.actually_payment }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">削除</el-button>
            <el-button size="mini" type="success" icon="el-icon-view" @click="printSalaryDetails(scope.$index, scope.row)">給与明細書</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage2" small layout="prev, pager, next" :page-size="pageSize" :total="total2" @current-change="handleSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="close()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- update salary -->
    <el-dialog :title="$t('general.edit')" :visible.sync="dialogUpdate" width="100%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <div style="padding-bottom:30px;">
          <el-row>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item label="社員名　：" prop="name" size="mini" style="width: 100%;">
                  {{ruleForm.name}}
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item label="対象年月　：" prop="" size="mini" style="width: 100%;">
                  {{ruleForm.year}}年{{ruleForm.month}}月
                  &nbsp;<el-date-picker value-format="yyyy-MM" v-model="ruleForm.salaryDate" type="month" placeholder="選択" @change="editDateChanged" style="width:120px;" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">&nbsp;</el-col>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button size="mini" style="width: 160px;" type="primary" icon="el-icon-circle-plus-outline" @click="handleAllowance2()">支給項目追加・編集</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="ここに設定は、新しく追加されたものに適用するか、現在の年月にのみ適用するかを選択できます">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:right;">
                <el-form-item size="mini" style="width: 90%;">
                  <el-button size="mini" style="width: 160px;" type="primary" icon="el-icon-circle-plus-outline" @click="handleDeduction2()">控除項目追加・編集</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <!-- <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button size="mini" style="width: 150px;" type="primary" icon="el-icon-refresh" @click="dataReCal()">給与明細額再計算</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="対象年月の変更があったら、再計算ボタンを押下することが必要です。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col> -->

            <!-- <el-col :span="4">
              <el-form-item size="mini" style="width: 80%;">
                <el-checkbox v-model="otherForm.insurance_is" @change="InsuranceChanged">社会保険参加</el-checkbox>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button type="primary" icon="el-icon-setting" @click="handleSalarySetting">設定</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="社員の保険参加状況、勤怠控除に関連することが設定できます。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="3">
              <el-form-item label="基本給" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.basic_salary" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="時間外手当" prop="overtime_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="役職手当" prop="assignment_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.assignment_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="資格手当" prop="qualification_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.qualification_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="通勤手当" prop="commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="立替交通費" prop="notax_commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="課税支給総合計" prop="tax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.tax_payment_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="非課税支給額合計" prop="notax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_payment_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="賞与" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.bonus" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance1 != ''" :label="otherForm.other_allowance1 + otherForm.allowance1_kannji" prop="other_allowance1" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_a1_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance2 != ''" :label="otherForm.other_allowance2 + otherForm.allowance2_kannji" prop="other_allowance2" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_a2_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="健康保険" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.health_insurance" @change="taxChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="厚生年金" prop="annuity" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annuity" @change="taxChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="雇用保険" prop="emp_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.emp_insurance" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="介護保険" prop="care_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.care_insurance" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="所得税" prop="income_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.income_tax" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="住民税" prop="resident_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.resident_tax" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="勤怠控除" prop="attendance_deduction" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.attendance_deduction" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="その他控除" prop="others" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.others" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction1 != ''" :label="otherForm.other_deduction1" prop="other_deduction1" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d1_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction2 != ''" :label="otherForm.other_deduction2" prop="other_deduction2" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d2_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="出勤日数" prop="work_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_days" @change="workDayChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="出勤時間" prop="work_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_hours" @change="workTimeChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業日数" prop="overtime_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業時間" prop="overtime_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給日数" prop="annual_vacation" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation" @change="annualVacationChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給消化日数" prop="annual_vacation_use" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation_use" @change="vacationUseChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="メモ" prop="remark" size="mini" style="width: 90%;">
                <el-input autosize type="textarea" :rows="2" v-model="ruleForm.remark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="総支給額" prop="salary_total" size="mini" style="width: 80%;padding-top:30px;">
                <el-input v-model="ruleForm.salary_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="控除合計額" prop="deduction_total" size="mini" style="width: 80%;padding-top:30px;">
                <el-input v-model="ruleForm.deduction_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item label="" prop="actually_payment" size="mini" style="width:80%;padding-top:30px;font-weight:bold;color:red; text-align: left;">
                <span style="font-size: 16px;">差引支給額</span>
                <el-input v-model="ruleForm.actually_payment" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item size="mini" style="width: 80%;">
                <el-button size="mini" style="width: 133px;margin-top:56px" type="primary" icon="el-icon-circle-close" @click="emptyDataOnly()">データクリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSalarySave('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- add salary -->
    <el-dialog title="給与明細書作成（新規）" :visible.sync="dialogAdd" width="100%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <div style="padding-bottom:30px;">
          <el-row>
            <el-col :span="4">
              <div style="text-align:left;">
                <el-form-item label="社員名　：" prop="name" size="mini" style="width: 100%;">
                  {{ruleForm.name}}
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="5">
              <div style="text-align:left;">
                <el-form-item label="対象年月" prop="salaryDate" size="mini" style="width: 80%;margin-left:14%">
                  <el-date-picker value-format="yyyy-MM" v-model="ruleForm.salaryDate" type="month" placeholder="選択" @change="dateChanged" style="width:110px;" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 100%;">
                  <el-button size="mini" style="width: 170px;" type="primary" icon="el-icon-caret-bottom" @click="dataImport()">前月データインポート</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="支給追加項目、控除追加項目、賞与及び立替交通費には、前月のデータをインポートされません。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button size="mini" style="width: 160px;" type="primary" icon="el-icon-circle-plus-outline" @click="handleAllowance">支給項目追加・編集</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="支給と控除項目追加・編集は給与明細書新規作成に適用されます。履歴給与明細書は適用されません。全員に適用と個人に適用2つのボタンが含まれています、個人設定の優先順位は全従業員よりも高い">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:right;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button size="mini" style="width: 160px;" type="primary" icon="el-icon-circle-plus-outline" @click="handleDeduction">控除項目追加・編集</el-button>
                </el-form-item>
              </div>
            </el-col>

          </el-row>
        </div>
        <div>
          <el-row>

            <!-- <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button size="mini" style="width: 156px;" type="primary" icon="el-icon-refresh" @click="dataReCal()">給与明細額再計算</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="対象年月の変更があったら、再計算ボタンを押下することが必要です。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col> -->

            <el-col :span="3">
              <div style="text-align:left;">
                <el-form-item size="mini" style="width: 80%;">
                  <el-button type="primary" icon="el-icon-setting" @click="handleSalarySetting">設定</el-button>
                  <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="社員の保険参加状況、勤怠控除に関連することが設定できます。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="3">
              <el-form-item label="基本給" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.basic_salary" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="時間外手当" prop="overtime_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="役職手当" prop="assignment_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.assignment_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="資格手当" prop="qualification_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.qualification_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="通勤手当" prop="commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="立替交通費" prop="notax_commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="課税支給総合計" prop="tax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.tax_payment_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="非課税支給額合計" prop="notax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_payment_total" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="賞与" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.bonus" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance1 != ''" :label="otherForm.other_allowance1 + otherForm.allowance1_kannji" prop="other_a1_values" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_a1_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance2 != ''" :label="otherForm.other_allowance2 + otherForm.allowance2_kannji" prop="other_a2_values" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_a2_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="健康保険" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.health_insurance" @change="taxChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="厚生年金" prop="annuity" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annuity" @change="taxChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="雇用保険" prop="emp_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.emp_insurance" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="介護保険" prop="care_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.care_insurance" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="所得税" prop="income_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.income_tax" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="住民税" prop="resident_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.resident_tax" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="勤怠控除" prop="attendance_deduction" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.attendance_deduction" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="その他控除" prop="others" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.others" @change="deductionTotalChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction1 != ''" :label="otherForm.other_deduction1" prop="other_deduction1" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d1_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction2 != ''" :label="otherForm.other_deduction2" prop="other_deduction2" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d2_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="出勤日数" prop="work_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_days" @change="workDayChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="出勤時間" prop="work_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_hours" @change="workTimeChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業日数" prop="overtime_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業時間" prop="overtime_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給日数" prop="annual_vacation" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation" @change="annualVacationChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給消化日数" prop="annual_vacation_use" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation_use" @change="vacationChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="メモ" prop="remark" size="mini" style="width: 90%;">
                <el-input autosize type="textarea" :rows="2" v-model="ruleForm.remark">
                </el-input>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction1 != ''" :label="otherForm.other_deduction1" prop="other_deduction1" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d1_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction2 != ''" :label="otherForm.other_deduction2" prop="other_deduction2" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.other_d2_values" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="総支給額" prop="salary_total" size="mini" style="width: 80%;padding-top:30px">
                <el-input v-model="ruleForm.salary_total" @change="actuallyPaymentChanged" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="控除合計額" prop="deduction_total" size="mini" style="width: 80%;padding-top:30px">
                <el-input v-model="ruleForm.deduction_total" @change="actuallyPaymentChanged" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="" prop="actually_payment" size="mini" style="width:80%;padding-top:30px;font-weight:bold;color:red; text-align: left;">
                <span style="font-size: 16px;">差引支給額</span>
                <el-input v-model="ruleForm.actually_payment" readonly="readonly"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="3">
              <el-form-item size="mini" style="width: 80%;">
                <el-button size="mini" style="width: 133px;margin-top:56px" type="primary" icon="el-icon-edit-outline" @click="dataRefresh()">データ計算</el-button>
              </el-form-item>
            </el-col> -->
            <el-col :span="3">
              <el-form-item size="mini" style="width: 80%;">
                <el-button size="mini" style="width: 133px;margin-top:56px" type="primary" icon="el-icon-circle-close" @click="emptyDataOnly()">データクリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSalary('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleSortChange">
      </el-pagination>
    </div>

    <!-- 項目追加・編集 -->
    <el-dialog title="控除項目追加・編集" :visible.sync="dialogDeduction" width="39%" :before-close="handleCloseOthers">
      <div style="text-align:left;">
        <el-button style="margin-bottom:20px;" type="primary" size="small" @click="otherAdd1()" icon="el-icon-circle-plus-outline">項目追加</el-button>
        <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="追加できるのは2つだけです">
          <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
        </el-popover>
      </div>
      <div style="text-align:left;">
        <el-form :model="otherForm" :label-position="labelPosition" label-width="80px">
          <el-form-item label="項目名前">
            <el-input size="small" style="width:300px;" v-model="otherForm.other_deduction1"></el-input>
            <el-button type="danger" size="small" @click="resetForm1()" icon="el-icon-delete">削除</el-button>
          </el-form-item>
          <el-form-item v-if="otherForm.other_deduction2 != ''" label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_deduction2"></el-input>
            <el-button type="danger" size="small" @click="resetForm2()" icon="el-icon-delete">削除</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem = true" style="width: 120px">保存</el-button>
        <!-- <el-button type="primary" @click="updateSalaryByOthers()" style="width: 120px">保存</el-button> -->
        <el-button @click="cancel_d">キャンセル</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支給項目追加・編集" :visible.sync="dialogAllowance" width="39%" :before-close="handleCloseOthers">
      <div style="text-align:left;">
        <el-button style="margin-bottom:20px;" type="primary" size="small" @click="otherAdd2()" icon="el-icon-circle-plus-outline">項目追加</el-button>
        <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="追加できるのは2つだけです">
          <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
        </el-popover>
      </div>
      <div style="text-align:left;">
        <el-form :model="otherForm" :label-position="labelPosition" label-width="80px">
          <el-form-item label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_allowance1"></el-input>
            <el-button type="danger" size="small" @click="resetForm3()" icon="el-icon-delete">削除</el-button>
            <el-checkbox v-model="otherForm.allowance1_isTax">課税対象</el-checkbox>
          </el-form-item>
          <el-form-item v-if="otherForm.other_allowance2 != ''" label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_allowance2"></el-input>
            <el-button type="danger" size="small" @click="resetForm4()" icon="el-icon-delete">削除</el-button>
            <el-checkbox v-model="otherForm.allowance2_isTax">課税対象</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem = true" style="width: 120px">保存</el-button>
        <!-- <el-button type="primary" @click="updateSalaryByOthers()" style="width: 120px">保存</el-button> -->
        <el-button @click="cancel_a">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- 項目追加・編集設定確認1 -->
    <el-dialog title="適用範囲を選択してください" :visible.sync="dialogSettingItem" width="40%" :before-close="handleCloseOthers">
      <div v-loading="loading">
        <p>
          <el-button type="primary" size="mini" @click="updateSalaryByOthers()">全員に適用</el-button>
          <el-button size="mini" @click="updateSalaryByOthersOne()">個人に適用</el-button>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem = false">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- 項目追加・編集，编辑页面用，可以变更发行过的给与明细项目 -->
    <el-dialog title="控除項目追加・編集" :visible.sync="dialogDeductionUpdate" width="39%" :before-close="handleCloseOthers">
      <div style="text-align:left;">
        <el-button style="margin-bottom:20px;" type="primary" size="small" @click="otherAdd1()" icon="el-icon-circle-plus-outline">項目追加</el-button>
        <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="追加できるのは2つだけです">
          <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
        </el-popover>
      </div>
      <div style="text-align:left;">
        <el-form :model="otherForm" :label-position="labelPosition" label-width="80px">
          <el-form-item label="項目名前">
            <el-input size="small" style="width:300px;" v-model="otherForm.other_deduction1"></el-input>
            <el-button type="danger" size="small" @click="resetForm1()" icon="el-icon-delete">削除</el-button>
          </el-form-item>
          <el-form-item v-if="otherForm.other_deduction2 != ''" label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_deduction2"></el-input>
            <el-button type="danger" size="small" @click="resetForm2()" icon="el-icon-delete">削除</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem2 = true" style="width: 120px">保存</el-button>
        <el-button @click="cancel_d">キャンセル</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支給項目追加・編集" :visible.sync="dialogAllowanceUpdate" width="39%" :before-close="handleCloseOthers">
      <div style="text-align:left;">
        <el-button style="margin-bottom:20px;" type="primary" size="small" @click="otherAdd2()" icon="el-icon-circle-plus-outline">項目追加</el-button>
        <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="追加できるのは2つだけです">
          <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
        </el-popover>
      </div>
      <div style="text-align:left;">
        <el-form :model="otherForm" :label-position="labelPosition" label-width="80px">
          <el-form-item label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_allowance1"></el-input>
            <el-button type="danger" size="small" @click="resetForm3()" icon="el-icon-delete">削除</el-button>
            <el-checkbox v-model="otherForm.allowance1_isTax">課税対象</el-checkbox>
          </el-form-item>
          <el-form-item v-if="otherForm.other_allowance2 != ''" label="項目名前">
            <el-input size="small" style="width:300px" v-model="otherForm.other_allowance2"></el-input>
            <el-button type="danger" size="small" @click="resetForm4()" icon="el-icon-delete">削除</el-button>
            <el-checkbox v-model="otherForm.allowance2_isTax">課税対象</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem2 = true" style="width: 120px">保存</el-button>
        <el-button @click="cancel_a">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- 項目追加・編集設定確認2 -->
    <el-dialog title="適用範囲を選択してください" :visible.sync="dialogSettingItem2" width="50%" :before-close="handleCloseOthers">
      <div v-loading="loading">
        <p>
          <el-button type="primary" size="mini" @click="updateSalaryByOthers()">全員に適用（新規給与明細書適用）</el-button>
          <el-button size="mini" @click="updateSalaryByOthersOne()">個人に適用（新規給与明細書適用）</el-button>
          <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="この設定は、新しく追加されたものに適用する。既存の給与明細書は適用されません">
            <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
          </el-popover>
        </p>
        <p>
          <el-button type="primary" size="mini" @click="updateOthersYearMonth('ruleForm')">全員に適用（現在の対象年月適用）</el-button>
          <el-button size="mini" @click="updateOthersOneYearMonth('ruleForm')">個人に適用（現在の対象年月適用）</el-button>
          <el-popover placement="top-start" title="説明:" width="300" trigger="hover" content="この設定は現在の対象年月にのみ適用する。既存の給与明細書は適用されます。">
            <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
          </el-popover>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSettingItem2 = false">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- dialog upload excel -->
    <el-dialog title="新規登録する給与明細のファイルを選択してください。" :visible.sync="dialogUploadExcel" width="39%" :before-close="handleClose">
      <div style="text-align:left;">
        <p>Excelファイルを利用して、複数の従業員の給与明細情報を一括で登録できます。</p>
        <p>なお、社員情報が人事管理に登録されない場合、インポートされた該当社員の給与明細情報は一覧に表示できません。</p>
      </div>
      <div>
        <el-row>
          <div class="el-form-item__content" style="padding-top:20px;">
            <el-upload ref="upload" accept=".xls,.xlsx" action="#" :auto-upload="false" :multiple="false" :file-list="fileList" :before-upload="beforeUpload" :http-request="uploadHttpRequest" :on-remove="fileRemove" :on-change="fileChange">
              <el-button size="medium" type="primary" icon="el-icon-folder-opened">ファイルを選択</el-button>
              <div slot="tip" class="el-upload__tip">
                <span style="color:red;">＊一回で一枚「.xlsx」ファイルのみ取込、かつ最大ファイルサイズ10Mまで。</span>
              </div>
            </el-upload>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-download" style="padding-bottom:50px;">
            <el-link @click="ExcelSample()" target="_blank">
              <span style="color:#20a0ff;">テンプレートファイルをダウンロード</span>
            </el-link>
          </div>
        </el-row>
        <el-row>
          <el-button type="primary" size="small" @click="submitUpload" style="width:100px;">取り込み</el-button>
          <el-button size="small" @click="closeDialog" style="width:100px;">キャンセル</el-button>
        </el-row>
        <el-row>
          <div style="text-align:left;　padding-top:10px;">
            <el-form :model="ruleForm" :label-position="labelPosition" label-width="100px">
              <el-form-item>
                <span>{{ruleForm.insertCount}}</span>&nbsp;件が取り込みました。
                未取込データ&nbsp;<span style="color:red;">{{ruleForm.noInsertCount}}</span>&nbsp;件があります。
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="closeDialog" type="primary" size="medium">閉じる</el-button>
      </span>
    </el-dialog>

    <!-- 送信前查看个人明细 -->
    <el-dialog title="個人給与明細詳細" :visible.sync="dialogSalaryDetailsData" width="85%" :before-close="detailsClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div style="text-align:left;">
              <el-form-item label="社員名">
                :&emsp;{{ruleForm.name}}
              </el-form-item>
              <el-form-item label="社員番号">
                :&emsp;{{ruleForm.employee_id}}
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div style="padding-top:30px;">
        <el-table :data="salaryDetailsData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
          <el-table-column label="年" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.year }}</span>
            </template>
          </el-table-column>

          <el-table-column label="月" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.month }}</span>
            </template>
          </el-table-column>

          <el-table-column label="基本給" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.basic_salary }}</span>
            </template>
          </el-table-column>

          <el-table-column label="時間外手当" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.overtime_allowance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="役職手当" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.assignment_allowance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="資格手当" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.qualification_allowance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="通勤手当" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.commuting_allowance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="立替交通費" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.notax_commuting_allowance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="賞与" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.bonus }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="this.otherForm.other_allowance1" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.other_a1_values }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="this.otherForm.other_allowance2" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.other_a2_values }}</span>
            </template>
          </el-table-column>
        </el-table>

        <br>
        <br>

        <el-table :data="salaryDetailsData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">

          <el-table-column label="健康保険" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.health_insurance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="厚生年金" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.annuity }}</span>
            </template>
          </el-table-column>

          <el-table-column label="雇用保険" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.emp_insurance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="介護保険" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.care_insurance }}</span>
            </template>
          </el-table-column>

          <el-table-column label="所得税" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.income_tax }}</span>
            </template>
          </el-table-column>

          <el-table-column label="住民税" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.resident_tax }}</span>
            </template>
          </el-table-column>

          <el-table-column label="勤怠控除" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.attendance_deduction }}</span>
            </template>
          </el-table-column>

          <el-table-column label="その他控除" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.others }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="this.otherForm.other_deduction1" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.other_d1_values }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="this.otherForm.other_deduction2" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.other_d2_values }}</span>
            </template>
          </el-table-column>

          <el-table-column label="" align="center">
            <template>
              <span>{{ "0" }}</span>
            </template>
          </el-table-column>

        </el-table>

        <br>
        <br>

        <el-table :data="salaryDetailsData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">

          <el-table-column label="出勤日数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.work_days }}</span>
            </template>
          </el-table-column>

          <el-table-column label="出勤時間" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.work_hours }}</span>
            </template>
          </el-table-column>

          <el-table-column label="残業日数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.overtime_days }}</span>
            </template>
          </el-table-column>

          <el-table-column label="残業時間" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.overtime_hours }}</span>
            </template>
          </el-table-column>

          <el-table-column label="有給日数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.annual_vacation }}</span>
            </template>
          </el-table-column>

          <el-table-column label="総支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.salary_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="控除合計額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deduction_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="差引支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.actually_payment }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="dialogSalaryDetailsData = false" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 一括送信一覧 -->
    <el-dialog title="送信一覧" :visible.sync="dialogSendMailTotally" width="70%" :before-close="cancelSend">
      <div v-loading="loading" style="padding-top:30px;">
        <el-form :inline="true" class="send">
          <el-form-item>
            <el-button type="primary" @click="sendSalaryTableMonthMulti()" style="width: 120px">送信確認</el-button>
            <el-button @click="dialogSendMailTotally = false">キャンセル</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="multipleTable" :data="salaryListMonthData" highlight-current-row border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>

          <el-table-column label="社員番号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employee_id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="メール" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.email }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendSalaryTableMonthMulti()" style="width: 120px">送信確認</el-button>
        <el-button @click="dialogSendMailTotally = false">キャンセル</el-button>
      </span>
    </el-dialog>
    <!-- 送信结果 -->
    <el-dialog title="メール送信結果" :visible.sync="dialogSendMailNum" width="46%" :before-close="cancelSend">
      <div style="text-align:left;margin-left:100px;">
        <p style="font-size:18px;　font-weight:bold; color:green;">メール送信が完了しました!</p>
      </div>
      <div>
        <el-row>
          <div style="text-align:left;　padding-top:10px;">
            <el-form :model="ruleForm" :label-position="labelPosition" label-width="100px">
              <el-form-item>
                メール&nbsp;<span>{{ruleForm.sendMailNum}}</span>&nbsp;件を送信しました。
                送信に失敗したメール&nbsp;<span style="color:red;">{{ruleForm.noSendMailNum}}</span>&nbsp;件があります。
              </el-form-item>
              <el-form-item>
                失敗したメール:&nbsp;<span>{{ruleForm.errorMail}}</span>
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancelSend()" type="primary" size="medium">閉じる</el-button>
      </span>
    </el-dialog>

    <!-- 給与明細設定 -->
    <el-dialog title="給与明細項目設定" :visible.sync="dialogSalarySetting" width="40%" :before-close="handleCloseOthers">
      <div style="text-align:left;">

        <el-form :model="settingForm" :label-position="labelPosition" label-width="170px">
          <el-row>
            <el-col :span="4">
              <el-form-item label="社員保険参加状況">
                <el-checkbox v-model="settingForm.emp_insurance_isJoin">雇用保険</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item>
                <el-checkbox v-model="settingForm.social_insurance_isJoin">社会保険（年金・健康保険）</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="月の所定労働日数">
            <el-input size="small" style="width:150px;" v-model="settingForm.basic_work_day"></el-input>
            &nbsp;日
          </el-form-item>
          <el-form-item label="月の所定労働時間">
            <el-input size="small" style="width:150px;" v-model="settingForm.basic_work_time"></el-input>
            &nbsp;時間
          </el-form-item>
          <el-form-item label="日単位の欠勤控除額">
            <el-input size="small" style="width:150px;" v-model="settingForm.day_absent_deduction" @change="dayAbsentDeductionChanged"></el-input>
            &nbsp;円
          </el-form-item>
          <el-form-item label="時間単位の欠勤控除額">
            <el-input size="small" style="width:150px;" v-model="settingForm.hour_absent_deduction" @change="hourAbsentDeductionChanged"></el-input>
            &nbsp;円
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSalarySettingAll = true" style="width: 120px">保存</el-button>
        <el-button @click="cancel_s">キャンセル</el-button>
      </span>
    </el-dialog>
    <!-- 給与明細設定全員判定 -->
    <el-dialog title="この設定を全員に適用しますか？" :visible.sync="dialogSalarySettingAll" width="40%" :before-close="handleCloseOthers">
      <div v-loading="loading">
        <p>
          <el-button type="primary" size="mini" @click="salarySettingAll">全員に適用</el-button>
          <el-button size="mini" @click="salarySettingOne">個人に適用</el-button>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSalarySettingAll = false">キャンセル</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          var Dtime = new Date('2019-3-1 00:00:00').getTime();
          // return time.getTime() > Date.now() + 30 * 8.64e7;
          return time.getTime() < Dtime || time.getTime() > Date.now() + 30 * 8.64e7;
        },
      },
      dialogSendMailTotally: false,
      dialogVisible: false,
      dialogUpdate: false,
      dialogAdd: false,
      dialogDeduction: false,
      dialogAllowance: false,
      dialogDeductionUpdate: false,
      dialogAllowanceUpdate: false,
      dialogSettingItem: false,
      dialogSettingItem2: false,
      dialogCompMonthSalary: false,
      dialogCompYearSalary: false,
      dialogSalaryDetailsData: false,
      dialogSendSalaryTableMonth: false,
      dialogUploadExcel: false,
      dialogSendMailNum: false,
      dialogSalarySetting: false,
      dialogSalarySettingAll: false,
      disablePage: false,
      compMonthSalaryData: [],
      compYearSalaryData: [],
      salaryListMonthData: [],
      srateList: [],
      tableData: [],
      multipleSelection: [],
      //个人给与明细一览数据
      salaryDetailsData: [],
      pageSize: 6,
      //首页分页
      currentPage: 1,
      //统计员工总数
      total: 0,
      //个人给与明细页面分页
      currentPage2: 1,
      //根据employee_id统计个人salary表信息总数
      total2: 0,
      currentPage3: 1,
      total3: 0,
      currentPage4: 1,
      total4: 0,
      sortName: "",
      sortOrder: "",
      year: "",
      labelPosition: 'right',
      otherForm: {
        other_deduction1: "",
        other_deduction2: "",
        other_allowance1: "",
        other_allowance2: "",
        allowance1_isTax: true,
        allowance2_isTax: true,
        insurance_is: true,
        allowance1_kannji: "",
        allowance2_kannji: "",
      },
      ruleForm: {
        // name:"",
        location: "",
        num: "",
        id: "",
        // employee_id: "",
        year: null,
        month: null,
        email: "",
        basic_salary: 0,
        overtime_allowance: 0,
        assignment_allowance: 0,
        qualification_allowance: 0,
        commuting_allowance: 0,
        notax_commuting_allowance: 0,
        tax_payment_total: 0,
        notax_payment_total: 0,
        health_insurance: 0,
        annuity: 0,
        emp_insurance: 0,
        care_insurance: 0,
        income_tax: 0,
        resident_tax: 0,
        attendance_deduction: 0,
        others: 0,
        work_days: 0,
        work_hours: 0,
        overtime_days: 0,
        overtime_hours: 0,
        annual_vacation: 0,
        salary_total: 0,
        deduction_total: 0,
        actually_payment: 0,
        bonus: 0,
        annual_vacation_use: 0,
        remark: "",

        temp1: 0,
        temp2: 0,
        noInsertCount: 0,
        insertCount: 0,
        salaryDate: null,
        sendMailNum: 0,
        noSendMailNum: 0,
        errorMail: "",

      },
      settingForm: {
        emp_insurance_isJoin: true,
        social_insurance_isJoin: true,
        basic_work_day: 0,
        basic_work_time: 0,
        day_absent_deduction: 0,
        hour_absent_deduction: 0
      },
      rules: {
        salaryDate: [{
          required: true,
          message: "日付を入力してください。",
          trigger: "blur",
        },],
        basic_salary: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        overtime_allowance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        assignment_allowance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        qualification_allowance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        commuting_allowance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        notax_commuting_allowance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        bonus: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        other_a1_values: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        other_a2_values: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        emp_insurance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        annuity: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        emp_insurance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        care_insurance: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        income_tax: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        resident_tax: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        attendance_deduction: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        others: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        other_d1_values: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        other_d2_values: [
          {
            pattern: /^\d+(,\d+)*$/,
            message: this.$t("半角数字やコンマ入り金額を入力してください。"),
          },
        ],
        work_days: [
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)*$/,
            message: this.$t("半角数字を入力してください。"),
          },
        ],
        work_hours: [
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)*$/,
            message: this.$t("半角数字を入力してください。"),
          },
        ],
        overtime_days: [
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)*$/,
            message: this.$t("半角数字を入力してください。"),
          },
        ],
        overtime_hours: [
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)*$/,
            message: this.$t("半角数字を入力してください。"),
          },
        ],
        annual_vacation: [
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)*$/,
            message: this.$t("半角数字を入力してください。"),
          },
        ]
      },
      salary_months: [
        {
          id: 1,
          name: "1",
        },
        {
          id: 2,
          name: "2",
        },
        {
          id: 3,
          name: "3",
        },
        {
          id: 4,
          name: "4",
        },
        {
          id: 5,
          name: "5",
        },
        {
          id: 6,
          name: "6",
        },
        {
          id: 7,
          name: "7",
        },
        {
          id: 8,
          name: "8",
        },
        {
          id: 9,
          name: "9",
        },
        {
          id: 10,
          name: "10",
        },
        {
          id: 11,
          name: "11",
        },
        {
          id: 12,
          name: "12",
        },
      ],

      locationList: [
        {
          value: "北海道",
          label: this.$t("NKHK.hokkaido"),
        },
        {
          value: "青森県",
          label: this.$t("NKHK.aomori"),
        },
        {
          value: "岩手県",
          label: this.$t("NKHK.iwate"),
        },
        {
          value: "宮城県",
          label: this.$t("NKHK.miyagi"),
        },
        {
          value: "秋田県",
          label: this.$t("NKHK.akita"),
        },
        {
          value: "山形県",
          label: this.$t("NKHK.yamagata"),
        },
        {
          value: "福島県",
          label: this.$t("NKHK.fukushima"),
        },
        {
          value: "茨城県",
          label: this.$t("NKHK.ibaraki"),
        },
        {
          value: "栃木県",
          label: this.$t("NKHK.tochigi"),
        },
        {
          value: "群馬県",
          label: this.$t("NKHK.gunma"),
        },
        {
          value: "埼玉県",
          label: this.$t("NKHK.saitama"),
        },
        {
          value: "千葉県",
          label: this.$t("NKHK.chiba"),
        },
        {
          value: "東京都",
          label: this.$t("NKHK.tokyo"),
        },
        {
          value: "神奈川県",
          label: this.$t("NKHK.kanagawa"),
        },
        {
          value: "新潟県",
          label: this.$t("NKHK.niigata"),
        },
        {
          value: "富山県",
          label: this.$t("NKHK.toyama"),
        },
        {
          value: "石川県",
          label: this.$t("NKHK.ishikawa"),
        },
        {
          value: "福井県",
          label: this.$t("NKHK.fukui"),
        },
        {
          value: "山梨県",
          label: this.$t("NKHK.yamanashi"),
        },
        {
          value: "長野県",
          label: this.$t("NKHK.nagano"),
        },
        {
          value: "岐阜県",
          label: this.$t("NKHK.gifu"),
        },
        {
          value: "静岡県",
          label: this.$t("NKHK.shizuoka"),
        },
        {
          value: "愛知県",
          label: this.$t("NKHK.aichi"),
        },
        {
          value: "三重県",
          label: this.$t("NKHK.mie"),
        },
        {
          value: "滋賀県",
          label: this.$t("NKHK.shiga"),
        },
        {
          value: "京都府",
          label: this.$t("NKHK.kyoto"),
        },
        {
          value: "大阪府",
          label: this.$t("NKHK.osaka"),
        },
        {
          value: "兵庫県",
          label: this.$t("NKHK.hyogo"),
        },
        {
          value: "奈良県",
          label: this.$t("NKHK.nara"),
        },
        {
          value: "和歌山県",
          label: this.$t("NKHK.wakayama"),
        },
        {
          value: "鳥取県",
          label: this.$t("NKHK.tottori"),
        },
        {
          value: "島根県",
          label: this.$t("NKHK.shimane"),
        },
        {
          value: "岡山県",
          label: this.$t("NKHK.okayama"),
        },
        {
          value: "広島県",
          label: this.$t("NKHK.hiroshima"),
        },
        {
          value: "山口県",
          label: this.$t("NKHK.yamaguchi"),
        },
        {
          value: "徳島県",
          label: this.$t("NKHK.tokushima"),
        },
        {
          value: "香川県",
          label: this.$t("NKHK.kagawa"),
        },
        {
          value: "愛媛県",
          label: this.$t("NKHK.ehime"),
        },
        {
          value: "高知県",
          label: this.$t("NKHK.kochi"),
        },
        {
          value: "福岡県",
          label: this.$t("NKHK.fukuoka"),
        },
        {
          value: "佐賀県",
          label: this.$t("NKHK.saga"),
        },
        {
          value: "長崎県",
          label: this.$t("NKHK.nagasaki"),
        },
        {
          value: "熊本県",
          label: this.$t("NKHK.kumamoto"),
        },
        {
          value: "大分県",
          label: this.$t("NKHK.oita"),
        },
        {
          value: "宮崎県",
          label: this.$t("NKHK.miyazaki"),
        },
        {
          value: "鹿児島県",
          label: this.$t("NKHK.kagoshima"),
        },
        {
          value: "沖縄県",
          label: this.$t("NKHK.okinawa"),
        },
      ],
      value: "",
      loading: false,
      fileList: "",
    };
  },

  methods: {
    dayAbsentDeductionChanged() {
      if (this.settingForm.basic_work_time === "0" || this.settingForm.basic_work_day === "0") {
        this.settingForm.hour_absent_deduction = 0;
      } else {
        var time1 = Number(this.settingForm.basic_work_time) / Number(this.settingForm.basic_work_day);
        //bug 修正，计算日控除没有取整。计算记过出现小数时，保存设定报错。
        this.settingForm.hour_absent_deduction =Math.round(Number(this.settingForm.day_absent_deduction) / time1) 
      }
    },
    hourAbsentDeductionChanged() {
      if (this.settingForm.basic_work_time === "0" || this.settingForm.basic_work_day === "0") {
        this.settingForm.day_absent_deduction = 0;
      } else {
        var time1 = Number(this.settingForm.basic_work_time) / Number(this.settingForm.basic_work_day);
        this.settingForm.day_absent_deduction = Number(this.settingForm.hour_absent_deduction) * time1
      }

    },
    workTimeChanged() {
      var time1 = Number(this.settingForm.basic_work_time) / Number(this.settingForm.basic_work_day);
      var time2 = Number(this.ruleForm.annual_vacation_use) * time1
      var time3 = Number(this.settingForm.basic_work_time) - Number(this.ruleForm.work_hours) - time2;
      var time4 = Number(this.ruleForm.work_hours) + time2;
      if (this.ruleForm.work_hours === "0" || this.ruleForm.work_hours === "" || Number(this.ruleForm.work_hours) > Number(this.settingForm.basic_work_time) || time4 > Number(this.settingForm.basic_work_time)) {
        this.ruleForm.attendance_deduction = 0;
      } else {
        this.ruleForm.attendance_deduction = Math.round(Number(this.settingForm.hour_absent_deduction) * time3);
        this.deductionTotalChanged();
      }
    },
    //前月剩余年休取得
    vacation() {
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      var year = salaryDateArr[0];
      var month = salaryDateArr[1];
      if (month == "01") {
        var tempYear = Number(year) - 1;
        var tempMonth = 12;
      } else {
        var tempYear = year;
        switch (month) {
          case "02":
            var tempMonth = "01";
            break;
          case "03":
            var tempMonth = "02";
            break;
          case "04":
            var tempMonth = "03";
            break;
          case "05":
            var tempMonth = "04";
            break;
          case "06":
            var tempMonth = "05";
            break;
          case "07":
            var tempMonth = "06";
            break;
          case "08":
            var tempMonth = "07";
            break;
          case "09":
            var tempMonth = "08";
            break;
          case "10":
            var tempMonth = "09";
            break;
          case "11":
            var tempMonth = "10";
            break;
          case "12":
            var tempMonth = "11";
            break;
        }
      }
      let postData = this.qs.stringify({
        year: tempYear,
        month: tempMonth,
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/selectSalayLastMonth",
        data: postData,
      })
        .then((response) => {
          if (response.data.annual_vacation != undefined) {
            this.ruleForm.annual_vacation = response.data.annual_vacation;
          } else if (this.ruleForm.annual_vacation != response.data.annual_vacation && this.ruleForm.annual_vacation != 0) {
            this.ruleForm.annual_vacation = this.ruleForm.annual_vacation;
          } else {
            this.ruleForm.annual_vacation = 0;
          }
          sessionStorage.setItem("annual_vacation", JSON.stringify(this.ruleForm.annual_vacation));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //日付変更
    //先检查所选年月是否存在，不存在再检查自定义项目。
    async dateChanged() {
      var temp = "";
      if (this.ruleForm.salaryDate != null) {
        await this.isNotExisting().then(res => {
          temp = res;
        });
        if (temp === "is") {
          return 0;
        }
        this.selectOthersYearMonth().then(v => {
          if (v === "666") {
            this.selectSalaryAdd();
          }
        });
      }
      if (this.ruleForm.basic_salary != 0) {
        this.basicSalaryChanged();
      }
      this.vacation();
    },
    async selectOthersYearMonth() {
      var salaryDateStr = "";
      var result = "";
      if (this.ruleForm.salaryDate === null || this.ruleForm.salaryDate === undefined) {
        salaryDateStr = this.ruleForm.year + "-" + this.ruleForm.month;
      } else {
        salaryDateStr = this.ruleForm.salaryDate;
      }
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      await this.axios({
        method: "post",
        url: "/selectOthersYearMonth",
        data: postData,
      })
        .then((response) => {
          if (response.data === "") {
            result = "666";
            return 0;
          }
          if (response.data.other_allowance1 === undefined) {
            this.otherForm.other_allowance1 = "";
            this.otherForm.other_allowance2 = "";
            this.otherForm.other_deduction1 = "";
            this.otherForm.other_deduction2 = "";
          } else {
            this.otherForm.other_allowance1 = response.data.other_allowance1;
            this.otherForm.other_allowance2 = response.data.other_allowance2;
            this.otherForm.other_deduction1 = response.data.other_deduction1;
            this.otherForm.other_deduction2 = response.data.other_deduction2;
            this.otherForm.allowance1_isTax = response.data.allowance1_isTax;
            this.otherForm.allowance2_isTax = response.data.allowance2_isTax;
            this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
            this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          }

        })
        .catch((error) => { });
      return result;
    },
    //編集画面日付変更
    editDateChanged() {
      this.isNotExisting();
      if (this.ruleForm.salaryDate === null || this.ruleForm.salaryDate === undefined) {
        this.ruleForm.salaryDate = this.ruleForm.year + "-" + this.ruleForm.month;
      } else {
        this.ruleForm.salaryDate = this.ruleForm.salaryDate;
      }
      this.basicSalaryChanged();
    },
    //雇用保険変更
    empInsuranceChanged() {
      if (this.settingForm.emp_insurance_isJoin == false) {
        this.ruleForm.emp_insurance = 0;
      }
    },
    //社会保険チェック
    socialinsuranceChanged() {
      if (this.settingForm.social_insurance_isJoin == false) {
        this.ruleForm.health_insurance = 0;
        this.ruleForm.annuity = 0;
        this.ruleForm.care_insurance = 0;
      }
    },
    //設定ボタン押下
    handleSalarySetting() {
      this.dialogSalarySetting = true;
      sessionStorage.setItem("emp_insurance_isJoin", JSON.stringify(this.settingForm.emp_insurance_isJoin));
      sessionStorage.setItem("social_insurance_isJoin", JSON.stringify(this.settingForm.social_insurance_isJoin));
      sessionStorage.setItem("basic_work_day", JSON.stringify(this.settingForm.basic_work_day));
      sessionStorage.setItem("basic_work_time", JSON.stringify(this.settingForm.basic_work_time));
      sessionStorage.setItem("day_absent_deduction", JSON.stringify(this.settingForm.day_absent_deduction));
      sessionStorage.setItem("hour_absent_deduction", JSON.stringify(this.settingForm.hour_absent_deduction));
    },
    //設定キャンセル
    cancel_s() {
      this.dialogSalarySetting = false;
      this.settingForm.emp_insurance_isJoin = JSON.parse(sessionStorage.getItem("emp_insurance_isJoin"));
      this.settingForm.social_insurance_isJoin = JSON.parse(sessionStorage.getItem("social_insurance_isJoin"));
      this.settingForm.basic_work_day = JSON.parse(sessionStorage.getItem("basic_work_day"));
      this.settingForm.basic_work_time = JSON.parse(sessionStorage.getItem("basic_work_time"));
      this.settingForm.day_absent_deduction = JSON.parse(sessionStorage.getItem("day_absent_deduction"));
      this.settingForm.hour_absent_deduction = JSON.parse(sessionStorage.getItem("hour_absent_deduction"));
    },
    //出勤日数変更
    workDayChanged() {
      var day1 = Number(this.settingForm.basic_work_day) - Number(this.ruleForm.work_days) - Number(this.ruleForm.annual_vacation_use);
      var day2 = Number(this.ruleForm.work_days) + Number(this.ruleForm.annual_vacation_use);
      //bug修正，前端直接传过来的ruleForm.work_days为String类型，原来判断===0错误。
      if (this.ruleForm.work_days === "0" || this.ruleForm.work_days === "" || Number(this.ruleForm.work_days) > Number(this.settingForm.basic_work_day) || day2 > Number(this.settingForm.basic_work_day)) {
        this.ruleForm.attendance_deduction = 0;
      } else {
        this.ruleForm.attendance_deduction = Math.round(Number(this.settingForm.day_absent_deduction) * day1);
        this.deductionTotalChanged();
      }
    },
    //有休changed
    vacationChanged() {
      this.workDayChanged();
      this.workTimeChanged();
      var annualVacation = JSON.parse(sessionStorage.getItem("annual_vacation"));
      if (annualVacation != 0 && this.ruleForm.salaryDate != null) {
        this.ruleForm.annual_vacation = Number(annualVacation) - Number(this.ruleForm.annual_vacation_use);
      }
    },
    annualVacationChanged() {
      sessionStorage.setItem("annual_vacation", JSON.stringify(this.ruleForm.annual_vacation));
    },
    vacationUseChanged() {
      var annual_vacation = JSON.parse(sessionStorage.getItem("annual_vacation"));
      if (this.ruleForm.annual_vacation != 0) {
        this.ruleForm.annual_vacation = Number(annual_vacation) - Number(this.ruleForm.annual_vacation_use);
      }
    },
    //設定検索
    selectSalarySetting(index, row) {
      let postData = this.qs.stringify({
        eid: row.id
      });
      this.axios({
        method: "post",
        url: "/selectSalarySetting",
        data: postData,
      })
        .then((response) => {
          if (response.data === null || response.data === "") {
            if (row.employee_type == "役員（雇用保険未加入）") {
              this.settingForm.emp_insurance_isJoin = false;
            } else  {
              this.settingForm.emp_insurance_isJoin = true;
            } 
            this.settingForm.social_insurance_isJoin = true;
            return 0;
          } else {
            if (row.employee_type == "役員（雇用保険未加入）") {
              this.settingForm.emp_insurance_isJoin = false;
            } else if (row.employee_type == "役員（雇用保険加入）") {
              this.settingForm.emp_insurance_isJoin = true;
            } else {
              this.settingForm.emp_insurance_isJoin = response.data.emp_insurance_isJoin;
            }

            this.settingForm.social_insurance_isJoin = response.data.social_insurance_isJoin;
            this.settingForm.basic_work_day = response.data.basic_work_day;
            this.settingForm.basic_work_time = response.data.basic_work_time;
            this.settingForm.day_absent_deduction = response.data.day_absent_deduction;
            this.settingForm.hour_absent_deduction = response.data.hour_absent_deduction;
          }

        })
        .catch((error) => {
          this.$message.error('エラー');
          console.log(error);
        });
    },
    //設定を全て適用
    salarySettingAll() {
      this.loading = true;
      let postData = this.qs.stringify({
        emp_insurance_isJoin: this.settingForm.emp_insurance_isJoin,
        social_insurance_isJoin: this.settingForm.social_insurance_isJoin,
        basic_work_day: this.settingForm.basic_work_day,
        basic_work_time: this.settingForm.basic_work_time,
        day_absent_deduction: this.settingForm.day_absent_deduction,
        hour_absent_deduction: this.settingForm.hour_absent_deduction
      });
      this.axios({
        method: "post",
        url: "/salarySettingAll",
        data: postData,
      })
        .then(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "設定完了しました。"
          });
          this.dialogSalarySetting = false;
          this.dialogSalarySettingAll = false;
          this.workTimeChanged();
          this.workDayChanged();
          this.empInsuranceChanged();
          this.socialinsuranceChanged();
          if (this.ruleForm.salaryDate === undefined || this.ruleForm.salaryDate != null) {
            this.basicSalaryChanged();
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    //設定を個人適用
    salarySettingOne() {
      let postData = this.qs.stringify({
        emp_insurance_isJoin: this.settingForm.emp_insurance_isJoin,
        social_insurance_isJoin: this.settingForm.social_insurance_isJoin,
        basic_work_day: this.settingForm.basic_work_day,
        basic_work_time: this.settingForm.basic_work_time,
        day_absent_deduction: this.settingForm.day_absent_deduction,
        hour_absent_deduction: this.settingForm.hour_absent_deduction,
        employee_id: JSON.parse(localStorage.getItem("salaryTemp_id"))
      });
      this.axios({
        method: "post",
        url: "/salarySettingOne",
        data: postData,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "設定完了しました。"
          });
          this.dialogSalarySetting = false;
          this.dialogSalarySettingAll = false;
          this.workTimeChanged();
          this.workDayChanged();
          this.empInsuranceChanged();
          this.socialinsuranceChanged();
          if (this.ruleForm.salaryDate === undefined || this.ruleForm.salaryDate != null) {
            this.basicSalaryChanged();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击table表格的排序箭头
    changeTableSort(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: this.sortName,
        sortOrder: this.sortOrder,
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
          for (var i; i < response.data.length; i++) {
            this.tableData[i].salary_month = Number(response.data[i].salary_month).toLocaleString();
          }
          this.getPages();
        })
        .catch((error) => {
          console.log(error);
        });
      localStorage.setItem("sortNameSalaryMain", JSON.stringify(this.sortName));
      localStorage.setItem("sortOrderSalaryMain", JSON.stringify(this.sortOrder));
    },
    //点击分页页码
    handleSortChange(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: JSON.parse(localStorage.getItem("sortNameSalaryMain")),
        sortOrder: JSON.parse(localStorage.getItem("sortOrderSalaryMain")),
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
          //给返回的金额添加逗号
          for (var i = 0; i < response.data.length; i++) {
            this.tableData[i].salary_month = Number(response.data[i].salary_month).toLocaleString();
          }
          this.getPages();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancel_a() {
      this.dialogAllowance = false;
      this.dialogAllowanceUpdate = false;
      this.otherForm.other_allowance1 = JSON.parse(sessionStorage.getItem("salaryOther_allowance1"));
      this.otherForm.other_allowance2 = JSON.parse(sessionStorage.getItem("salaryOther_allowance2"));
      this.otherForm.allowance1_isTax = JSON.parse(sessionStorage.getItem("allowance1_isTax"));
      this.otherForm.allowance2_isTax = JSON.parse(sessionStorage.getItem("allowance2_isTax"));
      this.ruleForm.other_a1_values = JSON.parse(sessionStorage.getItem("other_a1_values"));
      this.ruleForm.other_a2_values = JSON.parse(sessionStorage.getItem("other_a2_values"));
    },
    cancel_d() {
      this.dialogDeduction = false;
      this.dialogDeductionUpdate = false;
      this.otherForm.other_deduction1 = JSON.parse(sessionStorage.getItem("salaryOther_deduction1"));
      this.otherForm.other_deduction2 = JSON.parse(sessionStorage.getItem("salaryOther_deduction2"));
      this.ruleForm.other_d1_values = JSON.parse(sessionStorage.getItem("other_d1_values"));
      this.ruleForm.other_d2_values = JSON.parse(sessionStorage.getItem("other_d2_values"));
    },
    handleAllowance() {
      this.dialogAllowance = true;
      sessionStorage.setItem("salaryOther_allowance1", JSON.stringify(this.otherForm.other_allowance1));
      sessionStorage.setItem("salaryOther_allowance2", JSON.stringify(this.otherForm.other_allowance2));
      sessionStorage.setItem("allowance1_isTax", JSON.stringify(this.otherForm.allowance1_isTax));
      sessionStorage.setItem("allowance2_isTax", JSON.stringify(this.otherForm.allowance2_isTax));
      sessionStorage.setItem("other_a1_values", JSON.stringify(this.ruleForm.other_a1_values));
      sessionStorage.setItem("other_a2_values", JSON.stringify(this.ruleForm.other_a2_values));
    },
    handleAllowance2() {
      this.dialogAllowanceUpdate = true;
      sessionStorage.setItem("salaryOther_allowance1", JSON.stringify(this.otherForm.other_allowance1));
      sessionStorage.setItem("salaryOther_allowance2", JSON.stringify(this.otherForm.other_allowance2));
      sessionStorage.setItem("allowance1_isTax", JSON.stringify(this.otherForm.allowance1_isTax));
      sessionStorage.setItem("allowance2_isTax", JSON.stringify(this.otherForm.allowance2_isTax));
      sessionStorage.setItem("other_a1_values", JSON.stringify(this.ruleForm.other_a1_values));
      sessionStorage.setItem("other_a2_values", JSON.stringify(this.ruleForm.other_a2_values));
    },
    handleDeduction() {
      this.dialogDeduction = true;
      sessionStorage.setItem("salaryOther_deduction1", JSON.stringify(this.otherForm.other_deduction1));
      sessionStorage.setItem("salaryOther_deduction2", JSON.stringify(this.otherForm.other_deduction2));
      sessionStorage.setItem("other_d1_values", JSON.stringify(this.ruleForm.other_d1_values));
      sessionStorage.setItem("other_d2_values", JSON.stringify(this.ruleForm.other_d2_values));
    },
    handleDeduction2() {
      this.dialogDeductionUpdate = true;
      sessionStorage.setItem("salaryOther_deduction1", JSON.stringify(this.otherForm.other_deduction1));
      sessionStorage.setItem("salaryOther_deduction2", JSON.stringify(this.otherForm.other_deduction2));
      sessionStorage.setItem("other_d1_values", JSON.stringify(this.ruleForm.other_d1_values));
      sessionStorage.setItem("other_d2_values", JSON.stringify(this.ruleForm.other_d2_values));
    },
    ExcelSample() {
      window.open("/pdfSample/sample_import.xlsx");
    },
    InsuranceChanged() {
      if (this.otherForm.insurance_is == false) {
        this.ruleForm.health_insurance = 0;
        this.ruleForm.annuity = 0;
        this.ruleForm.emp_insurance = 0;
        this.ruleForm.care_insurance = 0;
      }
    },
    dataImport() {
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      var year = salaryDateArr[0];
      var month = salaryDateArr[1];
      if (month == "01") {
        var tempYear = Number(year) - 1;
        var tempMonth = 12;
      } else {
        var tempYear = year;
        switch (month) {
          case "02":
            var tempMonth = "01";
            break;
          case "03":
            var tempMonth = "02";
            break;
          case "04":
            var tempMonth = "03";
            break;
          case "05":
            var tempMonth = "04";
            break;
          case "06":
            var tempMonth = "05";
            break;
          case "07":
            var tempMonth = "06";
            break;
          case "08":
            var tempMonth = "07";
            break;
          case "09":
            var tempMonth = "08";
            break;
          case "10":
            var tempMonth = "09";
            break;
          case "11":
            var tempMonth = "10";
            break;
          case "12":
            var tempMonth = "11";
            break;
        }
      }
      let postData = this.qs.stringify({
        year: tempYear,
        month: tempMonth,
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/selectSalayLastMonth",
        data: postData,
      })
        .then((response) => {
          if (response.data.basic_salary == null) {
            this.$message({
              type: "warning",
              message: "前月のデータはありません",
            });
          } else {
            this.ruleForm.basic_salary = response.data.basic_salary;
            this.ruleForm.overtime_allowance = response.data.overtime_allowance;
            this.ruleForm.assignment_allowance = response.data.assignment_allowance;
            this.ruleForm.qualification_allowance = response.data.qualification_allowance;
            this.ruleForm.commuting_allowance = response.data.commuting_allowance;
            // this.ruleForm.notax_commuting_allowance = response.data.notax_commuting_allowance;
            this.ruleForm.tax_payment_total = response.data.tax_payment_total;
            this.ruleForm.notax_payment_total = response.data.notax_payment_total;
            this.ruleForm.health_insurance = response.data.health_insurance;
            this.ruleForm.annuity = response.data.annuity;
            this.ruleForm.emp_insurance = response.data.emp_insurance;
            this.ruleForm.care_insurance = response.data.care_insurance;
            this.ruleForm.income_tax = response.data.income_tax;
            this.ruleForm.resident_tax = response.data.resident_tax;
            this.ruleForm.attendance_deduction = response.data.attendance_deduction;
            this.ruleForm.others = response.data.others;
            this.ruleForm.work_days = response.data.work_days;
            this.ruleForm.work_hours = response.data.work_hours;
            this.ruleForm.overtime_days = response.data.overtime_days;
            this.ruleForm.overtime_hours = response.data.overtime_hours;
            this.ruleForm.annual_vacation = response.data.annual_vacation;
            this.ruleForm.salary_total = response.data.salary_total;
            this.ruleForm.deduction_total = response.data.deduction_total;
            this.ruleForm.actually_payment = response.data.actually_payment;
            // this.ruleForm.other_d1_values = response.data.other_d1_values;
            // this.ruleForm.other_d2_values = response.data.other_d2_values;
            // this.ruleForm.other_a1_values = response.data.other_a1_values;
            // this.ruleForm.other_a2_values = response.data.other_a2_values;
            // this.ruleForm.bonus = response.data.bonus;
            this.taxPaymentTotalChanged();
            this.noTaxPaymentTotalChanged();
            this.salaryTotalChanged();
            this.deductionTotalChanged();
            this.handleToNumber();
            this.actuallyPaymentChanged();
            this.handleToMoney();
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
    //编辑自定义项目，公司全员适用（针对新规，不影响已经生成的给与明细信息）
    updateSalaryByOthers() {
      (this.ruleForm.other_d1_values != "" && this.otherForm.other_deduction1 != "") ? this.ruleForm.other_d1_values : this.ruleForm.other_d1_values = 0;
      (this.ruleForm.other_d2_values != "" && this.otherForm.other_deduction2 != "") ? this.ruleForm.other_d2_values : this.ruleForm.other_d2_values = 0;
      (this.ruleForm.other_a1_values != "" && this.otherForm.other_allowance1 != "") ? this.ruleForm.other_a1_values : this.ruleForm.other_a1_values = 0;
      (this.ruleForm.other_a2_values != "" && this.otherForm.other_allowance2 != "") ? this.ruleForm.other_a2_values : this.ruleForm.other_a2_values = 0;
      this.handleToNumber();
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
        other_deduction1: this.otherForm.other_deduction1,
        other_deduction2: this.otherForm.other_deduction2,
        other_allowance1: this.otherForm.other_allowance1,
        other_allowance2: this.otherForm.other_allowance2,
        allowance1_isTax: this.otherForm.allowance1_isTax,
        allowance2_isTax: this.otherForm.allowance2_isTax,
      });
      this.axios({
        method: "post",
        url: "/updateSalaryByOthers",
        data: postData,
      })
        .then((response) => {
          this.dialogSettingItem = false,
            this.dialogSettingItem2 = false,
            this.dialogDeduction = false,
            this.dialogAllowance = false,
            this.dialogDeductionUpdate = false,
            this.dialogAllowanceUpdate = false,
            this.$message({
              type: "success",
              message: "保存しました。",
            });
          this.selectSalaryAdd();
          this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
          this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          this.salaryTotalChanged();
          this.taxPaymentTotalChanged();
          this.noTaxPaymentTotalChanged();
          this.deductionTotalChanged();
          this.handleToMoney();
          this.basicSalaryChanged();
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: "保存できませんでした。",
          });
          console.log(error);
        });
    },
    //编辑自定义项目，个人适用（针对新规，不影响已经生成的给与明细信息）
    updateSalaryByOthersOne() {
      (this.ruleForm.other_d1_values != "" && this.otherForm.other_deduction1 != "") ? this.ruleForm.other_d1_values : this.ruleForm.other_d1_values = 0;
      (this.ruleForm.other_d2_values != "" && this.otherForm.other_deduction2 != "") ? this.ruleForm.other_d2_values : this.ruleForm.other_d2_values = 0;
      (this.ruleForm.other_a1_values != "" && this.otherForm.other_allowance1 != "") ? this.ruleForm.other_a1_values : this.ruleForm.other_a1_values = 0;
      (this.ruleForm.other_a2_values != "" && this.otherForm.other_allowance2 != "") ? this.ruleForm.other_a2_values : this.ruleForm.other_a2_values = 0;
      this.handleToNumber();
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
        other_deduction1: this.otherForm.other_deduction1,
        other_deduction2: this.otherForm.other_deduction2,
        other_allowance1: this.otherForm.other_allowance1,
        other_allowance2: this.otherForm.other_allowance2,
        allowance1_isTax: this.otherForm.allowance1_isTax,
        allowance2_isTax: this.otherForm.allowance2_isTax,
      });
      this.axios({
        method: "post",
        url: "/updateSalaryByOthersOne",
        data: postData,
      })
        .then((response) => {
          this.dialogSettingItem = false,
            this.dialogSettingItem2 = false,
            this.dialogDeduction = false,
            this.dialogAllowance = false,
            this.dialogDeductionUpdate = false,
            this.dialogAllowanceUpdate = false,
            this.$message({
              type: "success",
              message: "保存しました。",
            });
          this.selectSalaryAdd();
          this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
          this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          this.salaryTotalChanged();
          this.taxPaymentTotalChanged();
          this.noTaxPaymentTotalChanged();
          this.deductionTotalChanged();
          this.handleToMoney();
          this.basicSalaryChanged();
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: "保存できませんでした。",
          });
          console.log(error);
        });
    },
    //新规时设定自定义项目，公司全员仅当前年月适用。
    //此方法暂不使用。
    updateOthersYearMonth2(ruleForm) {
      if (this.ruleForm.salaryDate === null) {
        this.$message.error('対象年月を設定してください。');
        return 0;
      } else {
        var salaryDateArr = this.ruleForm.salaryDate.split("-");
      }
      (this.ruleForm.other_d1_values != "" && this.otherForm.other_deduction1 != "") ? this.ruleForm.other_d1_values : this.ruleForm.other_d1_values = 0;
      (this.ruleForm.other_d2_values != "" && this.otherForm.other_deduction2 != "") ? this.ruleForm.other_d2_values : this.ruleForm.other_d2_values = 0;
      (this.ruleForm.other_a1_values != "" && this.otherForm.other_allowance1 != "") ? this.ruleForm.other_a1_values : this.ruleForm.other_a1_values = 0;
      (this.ruleForm.other_a2_values != "" && this.otherForm.other_allowance2 != "") ? this.ruleForm.other_a2_values : this.ruleForm.other_a2_values = 0;
      this.handleToNumber();
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
        other_deduction1: this.otherForm.other_deduction1,
        other_deduction2: this.otherForm.other_deduction2,
        other_allowance1: this.otherForm.other_allowance1,
        other_allowance2: this.otherForm.other_allowance2,
        allowance1_isTax: this.otherForm.allowance1_isTax,
        allowance2_isTax: this.otherForm.allowance2_isTax,
      });
      this.axios({
        method: "post",
        url: "/updateOthersYearMonth",
        data: postData,
      })
        .then((response) => {
          this.updateSalary(ruleForm);
          this.dialogSettingItem = false,
            this.dialogSettingItem2 = false,
            this.dialogDeduction = false,
            this.dialogAllowance = false,
            this.dialogDeductionUpdate = false,
            this.dialogAllowanceUpdate = false,
            this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
          this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          this.salaryTotalChanged();
          this.taxPaymentTotalChanged();
          this.noTaxPaymentTotalChanged();
          this.deductionTotalChanged();
          this.handleToMoney();
          setTimeout(() => { this.basicSalaryChanged(); }, 300);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: "保存できませんでした。",
          });
          console.log(error);
        });
    },
    //编辑自定义项目，公司全员仅当前年月适用。
    updateOthersYearMonth(ruleForm) {
      (this.ruleForm.other_d1_values != "" && this.otherForm.other_deduction1 != "") ? this.ruleForm.other_d1_values : this.ruleForm.other_d1_values = 0;
      (this.ruleForm.other_d2_values != "" && this.otherForm.other_deduction2 != "") ? this.ruleForm.other_d2_values : this.ruleForm.other_d2_values = 0;
      (this.ruleForm.other_a1_values != "" && this.otherForm.other_allowance1 != "") ? this.ruleForm.other_a1_values : this.ruleForm.other_a1_values = 0;
      (this.ruleForm.other_a2_values != "" && this.otherForm.other_allowance2 != "") ? this.ruleForm.other_a2_values : this.ruleForm.other_a2_values = 0;
      this.handleToNumber();
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        month: this.ruleForm.month,
        other_deduction1: this.otherForm.other_deduction1,
        other_deduction2: this.otherForm.other_deduction2,
        other_allowance1: this.otherForm.other_allowance1,
        other_allowance2: this.otherForm.other_allowance2,
        allowance1_isTax: this.otherForm.allowance1_isTax,
        allowance2_isTax: this.otherForm.allowance2_isTax,
      });
      this.axios({
        method: "post",
        url: "/updateOthersYearMonth",
        data: postData,
      })
        .then((response) => {
          this.updateSalary(ruleForm);
          this.dialogSettingItem = false,
            this.dialogSettingItem2 = false,
            this.dialogDeduction = false,
            this.dialogAllowance = false,
            this.dialogDeductionUpdate = false,
            this.dialogAllowanceUpdate = false,
            this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
          this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          this.salaryTotalChanged();
          this.taxPaymentTotalChanged();
          this.noTaxPaymentTotalChanged();
          this.deductionTotalChanged();
          this.handleToMoney();
          setTimeout(() => { this.basicSalaryChanged(); }, 300);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: "保存できませんでした。",
          });
          console.log(error);
        });
    },
    //编辑自定义项目，针对个人仅当前年月适用。
    updateOthersOneYearMonth(ruleForm) {
      this.updateSalary(ruleForm);
      this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
      this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
      this.salaryTotalChanged();
      this.taxPaymentTotalChanged();
      this.noTaxPaymentTotalChanged();
      this.deductionTotalChanged();
      this.handleToMoney();
      setTimeout(() => { this.basicSalaryChanged(); }, 300);
      this.dialogSettingItem = false;
      this.dialogSettingItem2 = false;
      this.dialogDeductionUpdate = false;
      this.dialogAllowanceUpdate = false;
    },
    sendMailTotally() {
      this.axios.post("/currentUserPhone").then((response) => {
        if (response.data === null || response.data === undefined || response.data === "") {
          this.$message({
            type: "error",
            message: "SMS認証を行うため、携帯電話番号を登録してください。",
          });
          this.$router.push({ path: "/UserHome" });
          return 0
        }

      });
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/salaryListMonth",
        data: postData,
      })
        .then((response) => {
          this.salaryListMonthData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.dialogSendMailTotally = true;

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    otherAdd1() {
      this.otherForm.other_deduction2 = " ";
    },
    otherAdd2() {
      this.otherForm.other_allowance2 = " ";
    },
    resetForm1() {
      this.otherForm.other_deduction1 = "";
      this.ruleForm.other_d1_values = 0;
    },
    resetForm2() {
      this.otherForm.other_deduction2 = "";
      this.ruleForm.other_d2_values = 0;
    },
    resetForm3() {
      this.otherForm.other_allowance1 = "";
      this.ruleForm.other_a1_values = 0;
    },
    resetForm4() {
      this.otherForm.other_allowance2 = "";
      this.ruleForm.other_a2_values = 0;
    },
    //打开送信确认页面。
    handleSandSalaryMonth(index, row) {
      this.axios.post("/currentUserPhone").then((response) => {
        if (response.data === null || response.data === undefined || response.data === "") {
          this.$message({
            type: "error",
            message: "SMS認証を行うため、携帯電話番号を登録してください。",
          });
          this.$router.push({ path: "/UserHome" });
          return 0
        }

      });
      this.dialogSendSalaryTableMonth = true;
      this.ruleForm.name = row.name;
      this.ruleForm.employee_id = row.employee_id;
      this.ruleForm.email = row.email;
    },
    //通过邮件给多人发送给与明细书
    sendSalaryTableMonthMulti() {
      this.loading = true;
      //将JS对象集合转换成JSON字符串
      let postData = JSON.stringify(this.multipleSelection);
      //请求头使用'application/json;charset=UTF-8',后端使用@RequestBody注解接收此请求的参数。
      this.axios({
        // traditional :true,
        method: "post",
        url: "/printSalaryTableMonthMulti",
        dataType: "json",
        data: postData,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      })
        .then((response) => {
          this.axios({
            // traditional :true,
            method: "post",
            url: "/sendSalaryTableMonthTotally",
            dataType: "json",
            data: postData,
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
            },
          })
            .then((response) => {
              this.loading = false;
              this.dialogSendMailNum = true;
              this.ruleForm.sendMailNum = response.data[0];
              this.ruleForm.noSendMailNum = response.data[1];
              if (response.data.length > 2) {
                this.$message({
                  type: "error",
                  message: "上記のメールアドレスが送信エラー、メールアドレスを確認してください",
                });
                for (var i = 2; i < response.data.length; i++) {
                  this.ruleForm.errorMail = this.ruleForm.errorMail + response.data[i] + ";";
                }
                return 0;
              }
              this.$message({
                type: "success",
                message: "メール送信をしました。",
              });
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: "error",
                message: "サーバーエラー",
              });
            });

        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "サーバーエラー",
          });
          console.log(error);
        });

    },
    //通过邮件发送个人月份给与明细书
    sendSalaryTableMonth(ruleForm) {
      this.loading = true;
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
        email: this.ruleForm.email,
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/printSalaryTableMonth",
        data: postData,
      })
        .then((response) => {
          this.axios({
            method: "post",
            url: "/sendSalaryTableMonth",
            data: postData,
          })
            .then((response) => {
              if (response.data.status === "success") {
                this.$message({
                  type: "success",
                  message: "メールを送信しました。",
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "メールを送信できません。メールアドレスを確認してください",
                });

              }

              this.loading = false;
              this.dialogSendSalaryTableMonth = false;
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: "サーバーエラー",
              });
              this.loading = false;
              console.log(error);
            });

        })
        .catch((error) => {
          console.log(error);
        });
    },
    preview(index, row) {
      var uid = window.localStorage.getItem('LoginUserId');
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/selectEmplistByEidAndUid",
        data: postData,
      })
        .then((response) => {
          // window.localStorage.setItem('tempEmpCode', response.data.code);
          // var EmpCode = window.localStorage.getItem('tempEmpCode');
          var EmpCode = response.data.code;
          var r_name = JSON.parse(localStorage.getItem("salaryTemp_name"));
          var year = row.year;
          var month = row.month;
          window.open("/pdf/給与明細書-" + r_name + year + "年" + month + "月度" + "no." + uid + EmpCode + ".pdf");
        })
        .catch((error) => {

        });

    },
    previewSalaryMonth(comCode) {
      var uid = window.localStorage.getItem('LoginUserId');
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      var year = salaryDateArr[0];
      var month = salaryDateArr[1];
      window.open("/pdf/給与明細一覧表-" + year + "年" + month + "月度" + "no." + uid + comCode + ".pdf");
    },
    previewSocialInsurance(comCode) {
      var uid = window.localStorage.getItem('LoginUserId');
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      var year = salaryDateArr[0];
      var month = salaryDateArr[1];
      window.open("/pdf/社会保険料一覧表-" + year + "年" + month + "月度" + "no." + uid + comCode + ".pdf");
    },
    previewSalaryBank(comCode) {
      var uid = window.localStorage.getItem('LoginUserId');
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      var year = salaryDateArr[0];
      var month = salaryDateArr[1];
      window.open("/pdf/総合振込依頼書-" + year + "年" + month + "月度" + "no." + uid + comCode + ".pdf");
    },
    previewSalaryYear(comCode) {
      var uid = window.localStorage.getItem('LoginUserId');
      var year = this.ruleForm.year;
      window.open("/pdf/会社年度給与明細一覧-" + year + "年" + "no." + uid + comCode + ".pdf");
    },
    printCompanySalaryYearList(ruleForm) {
      this.loading = true;
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
      });
      this.axios({
        method: "post",
        url: "/printCompanySalaryYearList",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          if (response.data != null && response.data != undefined) {
            var comCode = response.data;
            this.previewSalaryYear(comCode);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    printCompMonthSalary(ruleForm) {
      this.loading = true;
      if (this.ruleForm.salaryDate === null) {
        this.loading = false;
        this.$message({
          type: "error",
          message: "年月を入力してください"
        });
        return 0;
      }
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/printSalaryListMonth",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          if (response.data != null && response.data != undefined) {
            var comCode = response.data;
            this.previewSalaryMonth(comCode);
          }

          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    printSocialInsurance(ruleForm) {
      this.loading = true;
      if (this.ruleForm.salaryDate === null) {
        this.loading = false;
        this.$message({
          type: "error",
          message: "年月を入力してください"
        });
        return 0;
      }
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/printSocialInsurance",
        data: postData,
      })
        .then((response) => {

          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          if (response.data != null && response.data != undefined) {
            var comCode = response.data;
            this.previewSocialInsurance(comCode);
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    printSalaryBank(ruleForm) {
      this.loading = true;
      if (this.ruleForm.salaryDate === null) {
        this.loading = false;
        this.$message({
          type: "error",
          message: "年月を入力してください"
        });
        return 0;
      }
      var salaryDateStr = this.ruleForm.salaryDate;
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/printSalaryBank",
        data: postData,
      })
        .then((response) => {

          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          if (response.data != null && response.data != undefined) {
            var comCode = response.data;
            this.previewSalaryBank(comCode);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    printSalaryDetails(index, row) {
      this.loading = true;
      let postData = this.qs.stringify({
        employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
        year: row.year,
        month: row.month,
      });
      this.axios({
        method: "post",
        url: "/printSalaryTableMonth",
        data: postData,
      })
        .then((response) => {
          this.loading = false;
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          this.preview(index, row);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    close() {
      this.dialogVisible = false;
      this.currentPage2 = 1;
    },
    handleCloseOthers(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.otherForm.other_deduction1 = JSON.parse(sessionStorage.getItem("salaryOther_deduction1"));
          this.otherForm.other_deduction2 = JSON.parse(sessionStorage.getItem("salaryOther_deduction2"));
          this.otherForm.other_allowance1 = JSON.parse(sessionStorage.getItem("salaryOther_allowance1"));
          this.otherForm.other_allowance2 = JSON.parse(sessionStorage.getItem("salaryOther_allowance2"));
          this.otherForm.allowance1_isTax = JSON.parse(sessionStorage.getItem("allowance1_isTax"));
          this.otherForm.allowance2_isTax = JSON.parse(sessionStorage.getItem("allowance2_isTax"));
          this.ruleForm.other_a1_values = JSON.parse(sessionStorage.getItem("other_a1_values"));
          this.ruleForm.other_a2_values = JSON.parse(sessionStorage.getItem("other_a2_values"));
          this.ruleForm.other_d1_values = JSON.parse(sessionStorage.getItem("other_d1_values"));
          this.ruleForm.other_d2_values = JSON.parse(sessionStorage.getItem("other_d2_values"));
          done();
        })
        .catch((_) => { });
    },
    //送信前查看个人详细信息的dialog关闭方法。
    detailsClose() {
      this.dialogSalaryDetailsData = false;
    },
    handleCloseCompMonthSalary(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
          this.cancel();
        })
        .catch((_) => { });
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
          this.$refs.ruleForm.clearValidate();
        })
        .catch((_) => { });
      this.total3 = 1;
      this.total4 = 1;
      this.compMonthSalaryData = [];
      this.compYearSalaryData = [];
      this.$refs.upload.clearFiles() //清除上传文件对象
      this.fileList = [] //清空选择的文件列表
      this.$emit('close', false)
      this.dialogUploadExcel = false;
      this.emptySalaryData();
    },
    handleSalary(index, row) {
      let postData = this.qs.stringify({
        employee_id: row.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.salaryDetailsData = response.data;
          for (var i = 0; i < response.data.length; i++) {
            this.salaryDetailsData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.salaryDetailsData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.salaryDetailsData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }
          
          this.ruleForm.employee_id = row.employee_id;
          this.ruleForm.name = row.name;
        })
        .catch((error) => {
          console.log(error);
        });
      this.selectSalarySetting(index, row);

      this.axios({
        method: "post",
        url: "/rowsSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.total2 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.dialogVisible = true;
      localStorage.setItem("salaryTemp_name", JSON.stringify(row.name));
      localStorage.setItem("salaryTemp_id", JSON.stringify(row.employee_id));
    },

    handleSalaryChange() {
      // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage2,
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.salaryDetailsData = response.data;
          for (var i = 0; i < response.data.length; i++) {
            this.salaryDetailsData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.salaryDetailsData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.salaryDetailsData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.axios({
        method: "post",
        url: "/rowsSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.total2 = response.data;
          // alert(this.total2);
          // alert(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleCurrentChange() {
      // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageEmpList",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleToMoney() {
      this.ruleForm.basic_salary = this.ruleForm.basic_salary.toLocaleString();
      this.ruleForm.overtime_allowance = this.ruleForm.overtime_allowance.toLocaleString();
      this.ruleForm.assignment_allowance = this.ruleForm.assignment_allowance.toLocaleString();
      this.ruleForm.qualification_allowance = this.ruleForm.qualification_allowance.toLocaleString();
      this.ruleForm.commuting_allowance = this.ruleForm.commuting_allowance.toLocaleString();
      this.ruleForm.notax_commuting_allowance = this.ruleForm.notax_commuting_allowance.toLocaleString();
      this.ruleForm.tax_payment_total = this.ruleForm.tax_payment_total.toLocaleString();
      this.ruleForm.notax_payment_total = this.ruleForm.notax_payment_total.toLocaleString();
      this.ruleForm.health_insurance = this.ruleForm.health_insurance.toLocaleString();
      this.ruleForm.annuity = this.ruleForm.annuity.toLocaleString();
      this.ruleForm.emp_insurance = this.ruleForm.emp_insurance.toLocaleString();
      this.ruleForm.care_insurance = this.ruleForm.care_insurance.toLocaleString();
      this.ruleForm.income_tax = this.ruleForm.income_tax.toLocaleString();
      this.ruleForm.resident_tax = this.ruleForm.resident_tax.toLocaleString();
      this.ruleForm.attendance_deduction = this.ruleForm.attendance_deduction.toLocaleString();
      this.ruleForm.others = this.ruleForm.others.toLocaleString();
      this.ruleForm.annual_vacation = this.ruleForm.annual_vacation.toLocaleString();
      this.ruleForm.salary_total = this.ruleForm.salary_total.toLocaleString();
      this.ruleForm.deduction_total = this.ruleForm.deduction_total.toLocaleString();
      this.ruleForm.actually_payment = this.ruleForm.actually_payment.toLocaleString();
      this.ruleForm.other_d1_values = this.ruleForm.other_d1_values.toLocaleString();
      this.ruleForm.other_d2_values = this.ruleForm.other_d2_values.toLocaleString();
      this.ruleForm.other_a1_values = this.ruleForm.other_a1_values.toLocaleString();
      this.ruleForm.other_a2_values = this.ruleForm.other_a2_values.toLocaleString();
      this.ruleForm.bonus = this.ruleForm.bonus.toLocaleString();
    },
    handleToNumString() {
      this.ruleForm.basic_salary = String(this.ruleForm.basic_salary);
      this.ruleForm.overtime_allowance = String(this.ruleForm.overtime_allowance);
      this.ruleForm.assignment_allowance = String(this.ruleForm.assignment_allowance);
      this.ruleForm.qualification_allowance = String(this.ruleForm.qualification_allowance);
      this.ruleForm.commuting_allowance = String(this.ruleForm.commuting_allowance);
      this.ruleForm.notax_commuting_allowance = String(this.ruleForm.notax_commuting_allowance);
      this.ruleForm.tax_payment_total = String(this.ruleForm.tax_payment_total);
      this.ruleForm.notax_payment_total = String(this.ruleForm.notax_payment_total);
      this.ruleForm.health_insurance = String(this.ruleForm.health_insurance);
      this.ruleForm.annuity = String(this.ruleForm.annuity);
      this.ruleForm.emp_insurance = String(this.ruleForm.emp_insurance);
      this.ruleForm.care_insurance = String(this.ruleForm.care_insurance);
      this.ruleForm.income_tax = String(this.ruleForm.income_tax);
      this.ruleForm.resident_tax = String(this.ruleForm.resident_tax);
      this.ruleForm.attendance_deduction = String(this.ruleForm.attendance_deduction);
      this.ruleForm.others = String(this.ruleForm.others);
      this.ruleForm.annual_vacation = String(this.ruleForm.annual_vacation);
      this.ruleForm.salary_total = String(this.ruleForm.salary_total);
      this.ruleForm.deduction_total = String(this.ruleForm.deduction_total);
      this.ruleForm.actually_payment = String(this.ruleForm.actually_payment);
      this.ruleForm.other_d1_values = String(this.ruleForm.other_d1_values);
      this.ruleForm.other_d2_values = String(this.ruleForm.other_d2_values);
      this.ruleForm.other_a1_values = String(this.ruleForm.other_a1_values);
      this.ruleForm.other_a2_values = String(this.ruleForm.other_a2_values);
      this.ruleForm.bonus = String(this.ruleForm.bonus);
    },
    handleToNumber() {
      this.handleToNumString();
      this.ruleForm.basic_salary = Number(this.ruleForm.basic_salary.split(",").join(""));
      this.ruleForm.overtime_allowance = Number(this.ruleForm.overtime_allowance.split(",").join(""));
      this.ruleForm.assignment_allowance = Number(this.ruleForm.assignment_allowance.split(",").join(""));
      this.ruleForm.qualification_allowance = Number(this.ruleForm.qualification_allowance.split(",").join(""));
      this.ruleForm.commuting_allowance = Number(this.ruleForm.commuting_allowance.split(",").join(""));
      this.ruleForm.notax_commuting_allowance = Number(this.ruleForm.notax_commuting_allowance.split(",").join(""));
      this.ruleForm.tax_payment_total = Number(this.ruleForm.tax_payment_total.split(",").join(""));
      this.ruleForm.notax_payment_total = Number(this.ruleForm.notax_payment_total.split(",").join(""));
      this.ruleForm.health_insurance = Number(this.ruleForm.health_insurance.split(",").join(""));
      this.ruleForm.annuity = Number(this.ruleForm.annuity.split(",").join(""));
      this.ruleForm.emp_insurance = Number(this.ruleForm.emp_insurance.split(",").join(""));
      this.ruleForm.care_insurance = Number(this.ruleForm.care_insurance.split(",").join(""));
      this.ruleForm.income_tax = Number(this.ruleForm.income_tax.split(",").join(""));
      this.ruleForm.resident_tax = Number(this.ruleForm.resident_tax.split(",").join(""));
      this.ruleForm.attendance_deduction = Number(this.ruleForm.attendance_deduction.split(",").join(""));
      this.ruleForm.others = Number(this.ruleForm.others.split(",").join(""));
      this.ruleForm.annual_vacation = Number(this.ruleForm.annual_vacation.split(",").join(""));
      this.ruleForm.salary_total = Number(this.ruleForm.salary_total.split(",").join(""));
      this.ruleForm.deduction_total = Number(this.ruleForm.deduction_total.split(",").join(""));
      this.ruleForm.actually_payment = Number(this.ruleForm.actually_payment.split(",").join(""));
      this.ruleForm.other_d1_values = Number(this.ruleForm.other_d1_values.split(",").join(""));
      this.ruleForm.other_d2_values = Number(this.ruleForm.other_d2_values.split(",").join(""));
      this.ruleForm.other_a1_values = Number(this.ruleForm.other_a1_values.split(",").join(""));
      this.ruleForm.other_a2_values = Number(this.ruleForm.other_a2_values.split(",").join(""));
      this.ruleForm.bonus = Number(this.ruleForm.bonus.split(",").join(""));
    },
    handleEmpty() {
      (this.ruleForm.other_d1_values != "") ? this.ruleForm.other_d1_values : this.ruleForm.other_d1_values = 0;
      (this.ruleForm.other_d2_values != "") ? this.ruleForm.other_d2_values : this.ruleForm.other_d2_values = 0;
      (this.ruleForm.other_a1_values != "") ? this.ruleForm.other_a1_values : this.ruleForm.other_a1_values = 0;
      (this.ruleForm.other_a2_values != "") ? this.ruleForm.other_a2_values : this.ruleForm.other_a2_values = 0;
      (this.ruleForm.basic_salary != "") ? this.ruleForm.basic_salary : this.ruleForm.basic_salary = 0;
      (this.ruleForm.overtime_allowance != "") ? this.ruleForm.overtime_allowance : this.ruleForm.overtime_allowance = 0;
      (this.ruleForm.assignment_allowance != "") ? this.ruleForm.assignment_allowance : this.ruleForm.assignment_allowance = 0;
      (this.ruleForm.qualification_allowance != "") ? this.ruleForm.qualification_allowance : this.ruleForm.qualification_allowance = 0;
      (this.ruleForm.commuting_allowance != "") ? this.ruleForm.commuting_allowance : this.ruleForm.commuting_allowance = 0;
      (this.ruleForm.notax_commuting_allowance != "") ? this.ruleForm.notax_commuting_allowance : this.ruleForm.notax_commuting_allowance = 0;
      (this.ruleForm.tax_payment_total != "") ? this.ruleForm.tax_payment_total : this.ruleForm.tax_payment_total = 0;
      (this.ruleForm.notax_payment_total != "") ? this.ruleForm.notax_payment_total : this.ruleForm.notax_payment_total = 0;
      (this.ruleForm.health_insurance != "") ? this.ruleForm.health_insurance : this.ruleForm.health_insurance = 0;
      (this.ruleForm.annuity != "") ? this.ruleForm.annuity : this.ruleForm.annuity = 0;
      (this.ruleForm.emp_insurance != "") ? this.ruleForm.emp_insurance : this.ruleForm.emp_insurance = 0;
      (this.ruleForm.care_insurance != "") ? this.ruleForm.care_insurance : this.ruleForm.care_insurance = 0;
      (this.ruleForm.income_tax != "") ? this.ruleForm.income_tax : this.ruleForm.income_tax = 0;
      (this.ruleForm.resident_tax != "") ? this.ruleForm.resident_tax : this.ruleForm.resident_tax = 0;
      (this.ruleForm.attendance_deduction != "") ? this.ruleForm.attendance_deduction : this.ruleForm.attendance_deduction = 0;
      (this.ruleForm.others != "") ? this.ruleForm.others : this.ruleForm.others = 0;
      (this.ruleForm.work_days != "") ? this.ruleForm.work_days : this.ruleForm.work_days = 0;
      (this.ruleForm.work_hours != "") ? this.ruleForm.work_hours : this.ruleForm.work_hours = 0;
      (this.ruleForm.overtime_days != "") ? this.ruleForm.overtime_days : this.ruleForm.overtime_days = 0;
      (this.ruleForm.overtime_hours != "") ? this.ruleForm.overtime_hours : this.ruleForm.overtime_hours = 0;
      (this.ruleForm.annual_vacation != "") ? this.ruleForm.annual_vacation : this.ruleForm.annual_vacation = 0;
      (this.ruleForm.bonus != "") ? this.ruleForm.nonus : this.ruleForm.bonus = 0;
    },
    handleEdit(index, row) {
      let postData = this.qs.stringify({
        employee_id: row.employee_id,
        year: row.year,
        month: row.month,
      });
      this.axios({
        method: "post",
        url: "/selectOthersOneYearMonth",
        data: postData,
      })
        .then((response) => {
          if (response.data.other_allowance1 === undefined) {
            this.otherForm.other_allowance1 = "";
            this.otherForm.other_allowance2 = "";
            this.otherForm.other_deduction1 = "";
            this.otherForm.other_deduction2 = "";
          } else {
            this.otherForm.other_allowance1 = response.data.other_allowance1;
            this.otherForm.other_allowance2 = response.data.other_allowance2;
            this.otherForm.other_deduction1 = response.data.other_deduction1;
            this.otherForm.other_deduction2 = response.data.other_deduction2;
            this.otherForm.allowance1_isTax = response.data.allowance1_isTax;
            this.otherForm.allowance2_isTax = response.data.allowance2_isTax;
            this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
            this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          }

        })
        .catch((error) => { });
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
      this.ruleForm.name = JSON.parse(localStorage.getItem("salaryTemp_name"));
      this.handleToMoney();
      this.ruleForm.annual_vacation = row.annual_vacation;
      this.annualVacationChanged();

    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {

          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteSalary",
            data: postData,
          })
            .then((response) => {
              let postData = this.qs.stringify({
                page: this.currentPage2,
                employee_id: row.employee_id,
              });
              this.axios({
                method: "post",
                url: "/ListSalaryByEmployee_id",
                data: postData,
              })
                .then((response) => {
                  this.salaryDetailsData = response.data;
                  for (var i = 0; i < response.data.length; i++) {
                    this.salaryDetailsData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
                    this.salaryDetailsData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
                    this.salaryDetailsData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });

              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    updateSalarySave(ruleForm) {
      this.updateSalary(ruleForm);
      setTimeout(() => { this.handleSalaryChange(); }, 200);
      this.dialogUpdate = false;
      this.emptySalaryData();
    },
    updateSalary(ruleForm) {
      this.handleEmpty();
      this.handleToNumber();
      var salaryDateStr = "";
      if (this.ruleForm.salaryDate === null || this.ruleForm.salaryDate === undefined) {
        salaryDateStr = this.ruleForm.year + "-" + this.ruleForm.month;
      } else {
        salaryDateStr = this.ruleForm.salaryDate;
      }
      var salaryDateArr = salaryDateStr.split("-");
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            year: salaryDateArr[0],
            month: salaryDateArr[1],
            id: this.ruleForm.id,
            employee_id: this.ruleForm.employee_id,
            basic_salary: this.ruleForm.basic_salary,
            work_days: this.ruleForm.work_days,
            commuting_allowance: this.ruleForm.commuting_allowance,
            work_hours: this.ruleForm.work_hours,
            overtime_days: this.ruleForm.overtime_days,
            overtime_hours: this.ruleForm.overtime_hours,
            assignment_allowance: this.ruleForm.assignment_allowance,
            notax_commuting_allowance: this.ruleForm.notax_commuting_allowance,
            tax_payment_total: this.ruleForm.tax_payment_total,
            notax_payment_total: this.ruleForm.notax_payment_total,
            overtime_allowance: this.ruleForm.overtime_allowance,
            qualification_allowance: this.ruleForm.qualification_allowance,
            health_insurance: this.ruleForm.health_insurance,
            annuity: this.ruleForm.annuity,
            emp_insurance: this.ruleForm.emp_insurance,
            care_insurance: this.ruleForm.care_insurance,
            income_tax: this.ruleForm.income_tax,
            resident_tax: this.ruleForm.resident_tax,
            attendance_deduction: this.ruleForm.attendance_deduction,
            others: this.ruleForm.others,
            salary_total: this.ruleForm.salary_total,
            deduction_total: this.ruleForm.deduction_total,
            actually_payment: this.ruleForm.actually_payment,
            annual_vacation: this.ruleForm.annual_vacation,
            other_d1_values: this.ruleForm.other_d1_values,
            other_d2_values: this.ruleForm.other_d2_values,
            other_a1_values: this.ruleForm.other_a1_values,
            other_a2_values: this.ruleForm.other_a2_values,
            bonus: this.ruleForm.bonus,
            annual_vacation_use: this.ruleForm.annual_vacation_use,
            remark: this.ruleForm.remark,
            //自定义项目
            other_deduction1: this.otherForm.other_deduction1,
            other_deduction2: this.otherForm.other_deduction2,
            other_allowance1: this.otherForm.other_allowance1,
            other_allowance2: this.otherForm.other_allowance2,
            allowance1_isTax: this.otherForm.allowance1_isTax,
            allowance2_isTax: this.otherForm.allowance2_isTax,
          });
          this.axios({
            method: "post",
            url: "/updateSalary",
            data: postData,
          })
            .then((response) => {
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });

            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        }
      });
    },
    add(ruleForm) {
      this.handleToNumber();
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          var salaryDateStr = this.ruleForm.salaryDate
          var salaryDateArr = salaryDateStr.split("-");
          let postData = this.qs.stringify({
            employee_id: this.ruleForm.employee_id,
            basic_salary: this.ruleForm.basic_salary,
            year: salaryDateArr[0],
            month: salaryDateArr[1],
            work_days: this.ruleForm.work_days,
            commuting_allowance: this.ruleForm.commuting_allowance,
            work_hours: this.ruleForm.work_hours,
            overtime_days: this.ruleForm.overtime_days,
            overtime_hours: this.ruleForm.overtime_hours,
            assignment_allowance: this.ruleForm.assignment_allowance,
            notax_commuting_allowance: this.ruleForm.notax_commuting_allowance,
            tax_payment_total: this.ruleForm.tax_payment_total,
            notax_payment_total: this.ruleForm.notax_payment_total,
            overtime_allowance: this.ruleForm.overtime_allowance,
            qualification_allowance: this.ruleForm.qualification_allowance,
            health_insurance: this.ruleForm.health_insurance,
            annuity: this.ruleForm.annuity,
            emp_insurance: this.ruleForm.emp_insurance,
            care_insurance: this.ruleForm.care_insurance,
            income_tax: this.ruleForm.income_tax,
            resident_tax: this.ruleForm.resident_tax,
            attendance_deduction: this.ruleForm.attendance_deduction,
            others: this.ruleForm.others,
            salary_total: this.ruleForm.salary_total,
            deduction_total: this.ruleForm.deduction_total,
            actually_payment: this.ruleForm.actually_payment,
            annual_vacation: this.ruleForm.annual_vacation,
            other_d1_values: this.ruleForm.other_d1_values,
            other_d2_values: this.ruleForm.other_d2_values,
            other_a1_values: this.ruleForm.other_a1_values,
            other_a2_values: this.ruleForm.other_a2_values,
            bonus: this.ruleForm.bonus,
            annual_vacation_use: this.ruleForm.annual_vacation_use,
            remark: this.ruleForm.remark,
            //自定义项目
            other_deduction1: this.otherForm.other_deduction1,
            other_deduction2: this.otherForm.other_deduction2,
            other_allowance1: this.otherForm.other_allowance1,
            other_allowance2: this.otherForm.other_allowance2,
            allowance1_isTax: this.otherForm.allowance1_isTax,
            allowance2_isTax: this.otherForm.allowance2_isTax,
          });
          this.axios({
            method: "post",
            url: "/insertSalary",
            data: postData,
          })
            .then((response) => {
              this.axios({
                method: "post",
                url: "/ListSalaryByEmployee_id",
                data: this.qs.stringify({ employee_id: this.ruleForm.employee_id }),
              })
                .then((response) => {
                  this.salaryDetailsData = response.data;
                  this.handleSalaryChange();
                  // this.handleToMoney();
                  this.emptySalaryData();
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                  console.log(error);
                });
              this.dialogAdd = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    jump(path) {
      this.$router.push(path);
    },
    //健康保险和厚生年金变化时触发的事件。
    taxChanged() {
      //手动更改健康保险，厚生年金的值触发判断。该员工是否交年金保险。
      //如果不交年金保险taxflg为false。后台计算tax时，salary不要减去年金保险两项数值。
      this.deductionTotalChanged();
      this.handleToNumber();
      this.taxCalcu();
    },
    //控除合計額
    deductionTotalChanged() {
      this.handleToNumber();
      this.ruleForm.deduction_total =
        Math.round(Number(this.ruleForm.health_insurance) +
          Number(this.ruleForm.annuity) +
          Number(this.ruleForm.emp_insurance) +
          Number(this.ruleForm.care_insurance) +
          Number(this.ruleForm.income_tax) +
          Number(this.ruleForm.resident_tax) +
          Number(this.ruleForm.attendance_deduction) +
          Number(this.ruleForm.others) +
          Number(this.ruleForm.other_d1_values) +
          Number(this.ruleForm.other_d2_values));
      this.actuallyPaymentChanged();
      this.handleToMoney();
    },
    //総支給額
    salaryTotalChanged() {
      this.ruleForm.salary_total =
        Math.round(Number(this.ruleForm.basic_salary) +
          Number(this.ruleForm.overtime_allowance) +
          Number(this.ruleForm.assignment_allowance) +
          Number(this.ruleForm.qualification_allowance) +
          Number(this.ruleForm.commuting_allowance) +
          Number(this.ruleForm.notax_commuting_allowance) +
          Number(this.ruleForm.other_a1_values) +
          Number(this.ruleForm.other_a2_values)) +
        Number(this.ruleForm.bonus);
      this.actuallyPaymentChanged();
    },
    //課税支給総合計
    taxPaymentTotalChanged() {
      this.otherForm.allowance1_isTax == 1 ? (this.ruleForm.temp1 = this.ruleForm.other_a1_values) : (this.ruleForm.temp1 = 0);
      this.otherForm.allowance2_isTax == 1 ? (this.ruleForm.temp2 = this.ruleForm.other_a2_values) : (this.ruleForm.temp2 = 0);
      this.ruleForm.tax_payment_total =
        Number(this.ruleForm.basic_salary) +
        Number(this.ruleForm.overtime_allowance) +
        Number(this.ruleForm.assignment_allowance) +
        Number(this.ruleForm.qualification_allowance) +
        Number(this.ruleForm.commuting_allowance) +
        Number(this.ruleForm.temp1) +
        Number(this.ruleForm.temp2) +
        Number(this.ruleForm.bonus);
    },
    //非課税支給総合計
    noTaxPaymentTotalChanged() {
      this.otherForm.allowance1_isTax == 1 ? (this.ruleForm.temp1 = 0) : (this.ruleForm.temp1 = this.ruleForm.other_a1_values);
      this.otherForm.allowance2_isTax == 1 ? (this.ruleForm.temp2 = 0) : (this.ruleForm.temp2 = this.ruleForm.other_a2_values);
      this.ruleForm.notax_payment_total =
        Number(this.ruleForm.notax_commuting_allowance) +
        Number(this.ruleForm.temp1) +
        Number(this.ruleForm.temp2);
    },

    actuallyPaymentChanged() {
      this.ruleForm.actually_payment = Number(this.ruleForm.salary_total) - Number(this.ruleForm.deduction_total);
    },
    dataReCal() {
      if (this.ruleForm.salaryDate === null && this.ruleForm.year != null && this.ruleForm.month != null) {
        this.ruleForm.salaryDate = this.ruleForm.year + "-" + this.ruleForm.month;
      }
      if (this.ruleForm.salaryDate != null || this.ruleForm.salaryDate === undefined) {
        this.basicSalaryChanged();
        this.$message({
          message: '給与明細額を再計算しました。',
          type: 'success'
        });
      }
    },
    dataRefresh() {
      this.$message({
        message: 'データが計算しました。',
        type: 'success'
      });
    },
    basicSalaryChanged() {
      if (this.ruleForm.basic_salary === "0" || this.ruleForm.basic_salary === "" || this.ruleForm.basic_salary === null) {
        this.emptyDataOnly();
        return 0;
      }
      if (this.ruleForm.salaryDate === null) {
        this.$message.error('対象年月を設定してください。');
      } else {
        this.handleToNumber();
        this.otherForm.allowance1_isTax == 1 ? (this.ruleForm.temp1 = this.ruleForm.other_a1_values) : (this.ruleForm.temp1 = 0);
        this.otherForm.allowance2_isTax == 1 ? (this.ruleForm.temp2 = this.ruleForm.other_a2_values) : (this.ruleForm.temp2 = 0);

        this.axios.all([this.ListSRate(), this.taxCalcu(), this.CalEmpIns()])
          .then((response) => {
            this.taxPaymentTotalChanged();
            this.noTaxPaymentTotalChanged();
            this.salaryTotalChanged();
            this.deductionTotalChanged();
            this.handleToNumber();
            this.actuallyPaymentChanged();
            this.handleToMoney();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //年金、健康保険計算
    ListSRate() {
      var salaryDateStr = "";
      if (this.ruleForm.salaryDate === null || this.ruleForm.salaryDate === undefined) {
        salaryDateStr = this.ruleForm.year + "-" + this.ruleForm.month;
      } else {
        salaryDateStr = this.ruleForm.salaryDate;
      }
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        salary: Number(this.ruleForm.basic_salary) +
          Number(this.ruleForm.overtime_allowance) +
          Number(this.ruleForm.assignment_allowance) +
          Number(this.ruleForm.qualification_allowance) +
          Number(this.ruleForm.commuting_allowance) +
          Number(this.ruleForm.bonus),
        employee_id: this.ruleForm.employee_id,
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      return this.axios({
        method: "post",
        url: "/ListSRate",
        data: postData,
      })
        .then((response) => {
          if (this.settingForm.social_insurance_isJoin == false) {
            this.ruleForm.health_insurance = 0;
            this.ruleForm.care_insurance = 0;
            this.ruleForm.annuity = 0;
          } else {
            this.ruleForm.health_insurance = Math.round(response.data.h_half);
            this.ruleForm.care_insurance = Math.round(response.data.h_c_half - response.data.h_half);
            this.ruleForm.annuity = Math.round(response.data.annuity_half);
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    //所得税計算
    taxCalcu() {
      //如果不交年金保险taxflg为false。后台计算tax时，salary不要减去年金保险两项数值。
      //年金和健康保险同时为0时
      var taxTemp = true;
      if ((this.ruleForm.annuity + this.ruleForm.health_insurance) === 0 ) {
        taxTemp = false;
      }

      this.otherForm.allowance1_isTax == 1 ? (this.ruleForm.temp1 = this.ruleForm.other_a1_values) : (this.ruleForm.temp1 = 0);
      this.otherForm.allowance2_isTax == 1 ? (this.ruleForm.temp2 = this.ruleForm.other_a2_values) : (this.ruleForm.temp2 = 0);
      var salaryDateStr = "";
      if (this.ruleForm.salaryDate === null || this.ruleForm.salaryDate === undefined) {
        salaryDateStr = this.ruleForm.year + "-" + this.ruleForm.month;
      } else {
        salaryDateStr = this.ruleForm.salaryDate;
      }
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        salary:
          Number(this.ruleForm.basic_salary) +
          Number(this.ruleForm.overtime_allowance) +
          Number(this.ruleForm.assignment_allowance) +
          Number(this.ruleForm.qualification_allowance) +
          Number(this.ruleForm.commuting_allowance) +
          Number(this.ruleForm.temp1) +
          Number(this.ruleForm.temp2) +
          Number(this.ruleForm.bonus),
        employee_id: this.ruleForm.employee_id,
        year: salaryDateArr[0],
        month: salaryDateArr[1],
        //计算tax增加flg
        //如果不交年金保险taxflg为false。后台计算tax时，salary不要减去年金保险两项数值。
        taxFlg: taxTemp,
      });
      return this.axios({
        method: "post",
        url: "/taxCalcu",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.income_tax = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //雇用保険計算
    CalEmpIns() {
      this.otherForm.allowance1_isTax == 1 ? (this.ruleForm.temp1 = this.ruleForm.other_a1_values) : (this.ruleForm.temp1 = 0);
      this.otherForm.allowance2_isTax == 1 ? (this.ruleForm.temp2 = this.ruleForm.other_a2_values) : (this.ruleForm.temp2 = 0);
      let postData = this.qs.stringify({
        salary:
          Number(this.ruleForm.basic_salary) +
          Number(this.ruleForm.overtime_allowance) +
          Number(this.ruleForm.assignment_allowance) +
          Number(this.ruleForm.qualification_allowance) +
          Number(this.ruleForm.commuting_allowance) +
          Number(this.ruleForm.temp1) +
          Number(this.ruleForm.temp2) +
          Number(this.ruleForm.bonus),
        employee_id: this.ruleForm.employee_id
      });
      return this.axios({
        method: "post",
        url: "/CalEmpIns",
        data: postData,
      })
        .then((response) => {
          if (this.settingForm.emp_insurance_isJoin == true) {
            this.ruleForm.emp_insurance = response.data;
          } else {
            this.ruleForm.emp_insurance = 0;
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    emptyDataOnly() {
      this.ruleForm.basic_salary = 0;
      this.ruleForm.overtime_allowance = 0;
      this.ruleForm.assignment_allowance = 0;
      this.ruleForm.qualification_allowance = 0;
      this.ruleForm.commuting_allowance = 0;
      this.ruleForm.notax_commuting_allowance = 0;
      this.ruleForm.tax_payment_total = 0;
      this.ruleForm.notax_payment_total = 0;
      this.ruleForm.health_insurance = 0;
      this.ruleForm.annuity = 0;
      this.ruleForm.emp_insurance = 0;
      this.ruleForm.care_insurance = 0;
      this.ruleForm.income_tax = 0;
      this.ruleForm.resident_tax = 0;
      this.ruleForm.attendance_deduction = 0;
      this.ruleForm.others = 0;
      this.ruleForm.work_days = 0;
      this.ruleForm.work_hours = 0;
      this.ruleForm.overtime_days = 0;
      this.ruleForm.overtime_hours = 0;
      this.ruleForm.annual_vacation = 0;
      this.ruleForm.salary_total = 0;
      this.ruleForm.deduction_total = 0;
      this.ruleForm.actually_payment = 0;
      this.ruleForm.other_d1_values = 0;
      this.ruleForm.other_d2_values = 0;
      this.ruleForm.other_a1_values = 0;
      this.ruleForm.other_a2_values = 0;
      this.ruleForm.bonus = 0;
    },
    emptySalaryData() {
      this.ruleForm = {
        salaryDate: null,
        year: null,
        month: null,
        basic_salary: 0,
        overtime_allowance: 0,
        assignment_allowance: 0,
        qualification_allowance: 0,
        commuting_allowance: 0,
        notax_commuting_allowance: 0,
        tax_payment_total: 0,
        notax_payment_total: 0,
        health_insurance: 0,
        annuity: 0,
        emp_insurance: 0,
        care_insurance: 0,
        income_tax: 0,
        resident_tax: 0,
        attendance_deduction: 0,
        others: 0,
        work_days: 0,
        work_hours: 0,
        overtime_days: 0,
        overtime_hours: 0,
        annual_vacation: 0,
        salary_total: 0,
        deduction_total: 0,
        actually_payment: 0,
        other_d1_values: 0,
        other_d2_values: 0,
        other_a1_values: 0,
        other_a2_values: 0,
        insertCount: 0,
        noInsertCount: 0,
        bonus: 0,
        annual_vacation_use: 0,
        remark: "",

        temp1: 0,
        temp2: 0,
        noInsertCount: 0,
        insertCount: 0,
        salaryDate: null,
        sendMailNum: 0,
        noSendMailNum: 0,
        errorMail: "",

        employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
        name: JSON.parse(localStorage.getItem("salaryTemp_name")),
      }

    },
    emptySalarSettingData() {
      this.dialogSalarySettingAll = false;
      this.dialogSalarySetting = false;
      this.settingForm = {
        emp_insurance_isJoin: true,
        social_insurance_isJoin: true,
        basic_work_day: 0,
        basic_work_time: 0,
        day_absent_deduction: 0,
        hour_absent_deduction: 0
      };
    },
    cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogAdd = false;
      this.dialogCompMonthSalary = false;
      this.dialogCompYearSalary = false;
      this.dialogUploadExcel = false;
      this.dialogSendMailNum = false;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      this.total3 = 1;
      this.total4 = 1;
      this.compMonthSalaryData = [];
      this.compYearSalaryData = [];
      this.emptySalaryData();
      this.noInsertCount = 0;
      this.insertCount = 0;
      this.$refs[ruleForm].resetFields();
      // this.ruleForm.name = JSON.parse(localStorage.getItem("salaryTemp_name"));
    },
    cancelSend() {
      this.dialogSendMailNum = false;
      this.dialogSendSalaryTableMonth = false;
      this.dialogSendMailTotally = false;
      this.ruleForm.sendMailNum = 0;
      this.ruleForm.noSendMailNum = 0;
      this.ruleForm.errorMail = "";
    },
    selectSalaryAdd() {
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/selectSalaryAdd",
        data: postData,
      })
        .then((response) => {
          if (response.data.other_allowance1 === undefined) {
            this.otherForm.other_allowance1 = "";
            this.otherForm.other_allowance2 = "";
            this.otherForm.other_deduction1 = "";
            this.otherForm.other_deduction2 = "";
          } else {
            this.otherForm.other_allowance1 = response.data.other_allowance1;
            this.otherForm.other_allowance2 = response.data.other_allowance2;
            this.otherForm.other_deduction1 = response.data.other_deduction1;
            this.otherForm.other_deduction2 = response.data.other_deduction2;
            this.otherForm.allowance1_isTax = response.data.allowance1_isTax;
            this.otherForm.allowance2_isTax = response.data.allowance2_isTax;
            this.otherForm.allowance1_isTax === true ? this.otherForm.allowance1_kannji = "(課税)" : this.otherForm.allowance1_kannji = "(非課税)";
            this.otherForm.allowance2_isTax === true ? this.otherForm.allowance2_kannji = "(課税)" : this.otherForm.allowance2_kannji = "(非課税)";
          }

        })
        .catch((error) => { });
    },
    salaryAdd() {
      this.dialogAdd = true;
      this.emptySalaryData();
      this.selectSalaryAdd();
    },
    addSalary(ruleForm) {
      this.handleEmpty();
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.ruleForm.salaryDate != null) {
            var salaryDateStr = this.ruleForm.salaryDate
            var salaryDateArr = salaryDateStr.split("-");
            let postData = this.qs.stringify({
              employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
              year: salaryDateArr[0],
              month: salaryDateArr[1],
            });
            this.axios({
              method: "post",
              url: "/isNotExisting",
              data: postData,
            })
              .then((resp) => {
                if (resp.status == 200) {
                  var json = resp.data;
                  if (json.status == "not") {
                    this.add(ruleForm);
                  } else
                    if (json.status == "is") {
                      this.$message.error('選択した年月の給与明細がすでに存在しています。');
                    }
                }
              })
              .catch((error) => {
                this.$message.error('エラー');
                console.log(error);
              });
          }
        }
      });
    },
    async isNotExisting() {
      var is = "";
      if (this.ruleForm.salaryDate != null) {
        var salaryDateStr = this.ruleForm.salaryDate
        var salaryDateArr = salaryDateStr.split("-");
        let postData = this.qs.stringify({
          employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
          year: salaryDateArr[0],
          month: salaryDateArr[1],
        });
        await this.axios({
          method: "post",
          url: "/isNotExisting",
          data: postData,
        })
          .then((resp) => {
            if (resp.status == 200) {
              var json = resp.data;
              if (json.status == "is") {
                this.$message.error('選択した年月の給与明細がすでに存在しています。');
                is = "is";

              }
            }
          })
          .catch((error) => {
            this.$message.error('エラー');
            console.log(error);
          });
        return is;
      }

    },
    ListSalaryByYearMonth(index, row) {
      this.dialogSalaryDetailsData = true;
      var salaryDateStr = this.ruleForm.salaryDate
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
        employee_id: row.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByYearMonth",
        data: postData,
      })
        .then((response) => {
          this.salaryDetailsData = [response.data];
          this.salaryDetailsData[0].basic_salary = response.data.basic_salary.toLocaleString();
          this.salaryDetailsData[0].overtime_allowance = response.data.overtime_allowance.toLocaleString();
          this.salaryDetailsData[0].assignment_allowance = response.data.assignment_allowance.toLocaleString();
          this.salaryDetailsData[0].qualification_allowance = response.data.qualification_allowance.toLocaleString();
          this.salaryDetailsData[0].commuting_allowance = response.data.commuting_allowance.toLocaleString();
          this.salaryDetailsData[0].notax_commuting_allowance = response.data.notax_commuting_allowance.toLocaleString();
          this.salaryDetailsData[0].bonus = response.data.bonus.toLocaleString();
          this.salaryDetailsData[0].other_a1_values = response.data.other_a1_values.toLocaleString();
          this.salaryDetailsData[0].other_a2_values = response.data.other_a2_values.toLocaleString();
          this.salaryDetailsData[0].health_insurance = response.data.health_insurance.toLocaleString();
          this.salaryDetailsData[0].annuity = response.data.annuity.toLocaleString();
          this.salaryDetailsData[0].emp_insurance = response.data.emp_insurance.toLocaleString();
          this.salaryDetailsData[0].care_insurance = response.data.care_insurance.toLocaleString();
          this.salaryDetailsData[0].income_tax = response.data.income_tax.toLocaleString();
          this.salaryDetailsData[0].resident_tax = response.data.resident_tax.toLocaleString();
          this.salaryDetailsData[0].attendance_deduction = response.data.attendance_deduction.toLocaleString();
          this.salaryDetailsData[0].others = response.data.others.toLocaleString();
          this.salaryDetailsData[0].other_d1_values = response.data.other_d1_values.toLocaleString();
          this.salaryDetailsData[0].other_d2_values = response.data.other_d2_values.toLocaleString();
          this.salaryDetailsData[0].salary_total = response.data.salary_total.toLocaleString();
          this.salaryDetailsData[0].deduction_total = response.data.deduction_total.toLocaleString();
          this.salaryDetailsData[0].actually_payment = response.data.actually_payment.toLocaleString();
          this.ruleForm.employee_id = row.employee_id;
          this.ruleForm.name = row.name;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //会社月度给与明细一览页面的检索按钮
    compMonthSalary() {
      var salaryDateStr = this.ruleForm.salaryDate
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/companySalaryByDate",
        data: postData,
      })
        .then((response) => {
          // this.currentPage3 = 1;
          this.compMonthSalaryData = response.data;
          //将自定义项目赋值，详细情报页面可以获得自定义项目
          this.otherForm.other_allowance1 = response.data[0].other_allowance1;
          this.otherForm.other_allowance2 = response.data[0].other_allowance2;
          this.otherForm.other_deduction1 = response.data[0].other_deduction1;
          this.otherForm.other_deduction2 = response.data[0].other_deduction2;
          for (var i = 0; i < response.data.length; i++) {
            this.compMonthSalaryData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.compMonthSalaryData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.compMonthSalaryData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }

        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryList",
        data: postData,
      })
        .then((response) => {
          this.total3 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compYearSalary() {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        //        page: this.currentPage4,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByYear",
        data: postData,
      })
        .then((response) => {
          this.currentPage4 = 1;
          this.compYearSalaryData = response.data;
          for (var i = 0; i < response.data.length; i++) {
            this.compYearSalaryData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.compYearSalaryData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.compYearSalaryData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryListYear",
        data: postData,
      })
        .then((response) => {
          this.total4 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compMonthSalaryChange() {
      var salaryDateStr = this.ruleForm.salaryDate
      var salaryDateArr = salaryDateStr.split("-");
      let postData = this.qs.stringify({
        page: this.currentPage3,
        year: salaryDateArr[0],
        month: salaryDateArr[1],
      });
      this.axios({
        method: "post",
        url: "/companySalaryByDate",
        data: postData,
      })
        .then((response) => {
          this.compMonthSalaryData = response.data;
          for (var i = 0; i < response.data.length; i++) {
            this.compMonthSalaryData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.compMonthSalaryData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.compMonthSalaryData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryList",
        data: postData,
      })
        .then((response) => {
          this.total3 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compYearSalaryChange() {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        page: this.currentPage4,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByYear",
        data: postData,
      })
        .then((response) => {
          this.compYearSalaryData = response.data;
          for (var i = 0; i < response.data.length; i++) {
            this.compYearSalaryData[i].salary_total = Number(response.data[i].salary_total).toLocaleString();
            this.compYearSalaryData[i].deduction_total = Number(response.data[i].deduction_total).toLocaleString();
            this.compYearSalaryData[i].actually_payment = Number(response.data[i].actually_payment).toLocaleString();
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryListYear",
        data: postData,
      })
        .then((response) => {
          this.total4 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //---------------------------------------------------------------------------------------------------
    //upload excel 
    // 上传文件之前的钩子：判断上传文件格式、大小等，若返回false则停止上传
    beforeUpload(file) {
      //文件类型
      const isType = file.type === 'application/vnd.ms-excel'
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const fileType = isType || isTypeComputer
      if (!fileType) {
        this.$message.error('「.xls」または「.xlsx」ファイルをアプロードしてください！')
      }

      // 文件大小限制为10M
      const fileLimit = file.size / 1024 / 1024 < 10;
      if (!fileLimit) {
        this.$message.error('ファイルサイズ10Mまでアプロードしてください！')
      }
      return fileType && fileLimit
    },
    // 自定义上传方法，param是默认参数，可以取得file文件信息，具体信息如下图
    uploadHttpRequest(param) {
      const formData = new FormData() //FormData对象，添加参数只能通过append('key', value)的形式添加
      formData.append('mfile', param.file) //添加文件对象
      formData.append('uploadType', this.rulesType)
      const url = "/uploadExcel" //上传地址
      this.axios.post(url, formData)
        .then(res => {
          this.ruleForm.insertCount = res.data[0];
          this.ruleForm.noInsertCount = res.data[1];
          if (res.data[0] > 0 && res.data[1] === 0) {
            this.$message({
              type: "success",
              message: this.$t("取込完了しました。"),
            });
          }
          if (res.data[0] > 0 && res.data[1] > 0) {
            this.$message({
              type: "success",
              message: this.$t("一部データ取込完了しましたが、未取込データがあります。"),
            });
          }
          if (res.data[0] === 0 && res.data[1] > 0) {
            this.$message({
              type: "warning",
              message: this.$t("インポートされたデータはすでに登録しました。未登録データを選択してください。"),
            });
          }
          if (res.data[0] === 0 && res.data[1] === 0) {
            this.$message({
              type: "warning",
              message: this.$t("取込の時エラーができました。"),
            });
          }

          // const { data: { code, mark } } = res
          // if (code === 0) {
          //   param.onSuccess()  // 上传成功的文件显示绿色的对勾
          //   this.uploadMark = mark
          // }
          // return this.countData(this.uploadMark) //根据mark值调用统计结果接口，返回一个promise以便进行链式调用
        })
        // .then(res => { //链式调用，调用统计结果的响应
        //   const { data: { code, data } } = res
        //   if (code === 0) {
        //     console.log('统计结果', data)
        //   }
        // })
        .catch(err => {
          this.$message({
            type: "warning",
            message: this.$t("登録できませんでした。"),
          });
          // console.log('失败', err)
          param.onError() //上传失败的文件会从文件列表中删除
        })

    },
    // 点击上传：手动上传到服务器，此时会触发组件的http-request
    submitUpload() {
      this.$refs.upload.submit()
      this.$refs.upload.clearFiles() //清除上传文件对象
      this.fileList = [] //清空选择的文件列表
    },
    // 文件发生改变
    fileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
      }
    },
    // 移除选择的文件
    fileRemove(file, fileList) {
      if (fileList.length < 1) {
        this.uploadDisabled = true //未选择文件则禁用上传按钮
      }
    },
    // 取消
    closeDialog() {
      this.$refs.upload.clearFiles() //清除上传文件对象
      this.fileList = [] //清空选择的文件列表
      this.$emit('close', false)
      this.dialogUploadExcel = false;
      this.ruleForm.insertCount = "0",
        this.ruleForm.noInsertCount = "0"
    },

  },

  created() {
    this.axios
      .post("/pageEmpList")
      .then((response) => {
        this.tableData = response.data;
        for (var i = 0; i < response.data.length; i++) {
          this.tableData[i].salary_month = Number(response.data[i].salary_month).toLocaleString();
          // var key = i;
          // alert(response.data[i].code);
          // sessionStorage.setItem("TempCode"+key, response.data[i].code);
        }
      })
      .catch((error) => { });
    this.axios
      .post("/rowsEmpList")
      .then((response) => {
        this.total = response.data;

      })
      .catch((error) => { });

  },
};
</script>
<style scoped>
.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
.style1 {
  margin-right: 130px;
  padding: 0px;
  text-align: right;
}
.send {
  margin-right: 33px;
  padding: 0px;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/components/Salary/Salary.vue